import enUS from 'iview/dist/locale/en-US';

const en = {
  info1: 'This is already the first',
  info2: 'This is already the last',
  info03: 'Are you sure you would like to delete the info of this person?',
  info04: 'No results',
  info05: 'Download',
  info06: 'Upload',
  info07: 'Low',
  info08: 'Middle',
  info09: 'High',
  info10: 'Excellent',
  info11: 'Mailbox modification error',
  info12: 'Theme',
  info13: 'Date',
  info14: 'Switch password verification',
  info15: 'Wrong file type',
  info16: 'Reset',
  info17: 'HR Agent',
  info18: 'Luttica Cloud - Professional HR SAAS Cloud',
  info19: 'Are you sure you want to exit the system?',
  info20: 'Running',
  info21: 'Are you sure you want to delete the selected message?',
  info22: 'You have successfully tied your mailbox!',
  info23:
    'You need to fill in the employee id for the onboarding application, please process the entry application article by article!',
  info24: 'Yes',
  info25: 'No',
  info26: 'Employee self-help',
  info27: 'Auth. Time',
  info28: 'Auth. Method',
  info29: 'Auth. No.',
  info30: 'Auth. Account',
  info31: 'Seal',
  info32: 'Employee Auth. Mehtod',
  info33: 'E-Sign',
  info34: 'Certification',
  info35: 'Empty',
  info36: 'How to verify',
  info37: 'Completed',
  info38: 'In Progress',
  info39: 'Sign an Account',
  info40: 'Seal',
  info41: 'Organization Name',
  info42: 'Organization Code',
  info43: 'Legal Person',
  info44: 'Legel Person ID',
  info45: 'Headline name',
  info46: 'Province',
  info47: 'City',
  info48: 'Branch',
  info49: 'Four Elements of Bank Verification',
  info50: 'Carrier Three-factor Verification',
  info51: 'Amount of money paid',
  info52: 'Registration Type',
  info53: 'Enterprise Registration Type',
  info54: 'Enterprise Type',
  info55: 'Agent Registration',
  info56: 'Legal Entity Registration',
  info57: 'Ordinary Business',
  info58: 'Social Groups',
  info59: 'Institutions',
  info60: 'Private Non-enterprise Units',
  info61: 'Party and government and state institutions',
  info62: 'Organization Code',
  info63: 'Multi-proof one, pass social credit code number',
  info64: 'Business Registration Code',
  info65: 'Sign Notes',
  info66: 'Contract Templates',
  info67: 'Full Comparison',
  info68: 'Two-element comparison of business information',
  info69: 'Company Name',
  info70: 'Please fill in the full account bank information',
  info71: 'Menu',
  info72: 'Employees do not open a login account, can not send greetings!',
  info73: 'Please complete the company certification first!',
  info74: 'There are multiple companies in the data that cannot be signed in bulk!',
  info75: 'Name',
  info76: 'Sort',
  info77: 'Effective',
  info78: 'Language',
  info79: 'Chinese',
  info80: 'English',
  info81: 'No queries to matching organizations!',
  info82: 'Bulk Signing',
  info83: 'This is the last query data！',
  info84: 'Timing Task',
  info85: 'Cycle',
  info86: 'Days in advance',
  info87: 'Exchange Rate',
  info88: 'Currency',
  info89: 'Only Read',
  info90: 'Only Write',
  info91: 'Batch Processing',
  info92: 'Total Employee',
  info93: 'Fill out',
  info94: 'Working',
  info95: 'Rest',
  info96: 'On Leave',
  info97: 'Business Trip',
  info98: 'Going Out',
  info99: 'Working Overtime',
  info100: 'Please Select',
  info101: 'Detailed',
  info102: 'Deduct Quota:',
  info103: 'Type',
  loginTitle: 'Provide professional services for talents.',
  display_password: 'Display Password',
  hidden_password: 'Hidden Password',
  fullscreenMax: 'Maximization',
  fullscreenMin: 'Normal',
  aboutUs: 'About Us',
  callUs: 'Contact Us',
  select: 'Select All',
  cancelSelect: 'Deselect',
  termsOfService: 'Service Item',
  copyright: 'Copyright',
  company: 'Luttica',
  right: 'All Right Reserved',
  close: 'Close',
  export: 'Export',
  print: 'Print',
  identyDiscern: 'ID card identification',
  idPhoto: 'Document photo',
  title01: 'My Application',
  title02: 'My News',
  title03: 'Contact us',
  title04: 'Please scan the code with mobile phone.',
  title05:
    'The reset password link has been sent to the mailbox. Please input the mailbox to reset the password.',
  title06: 'User Protocol',
  title07: 'I have read the user agreement carefully.',
  title08: 'Upload background',
  title09: 'Agent',
  title10: 'Proxy Setting',
  title11: 'Are you sure you want to delete it?',
  title12: 'Prompt',
  title13: 'Cancel Proxy',
  title14: 'Select User',
  title15: 'Selection Menu',
  title16: 'Period',
  title17: 'Start Time',
  title18: 'End Time',
  title19: 'Query',
  title20: 'Agent',
  title21: 'Unread',
  title22: 'Read',
  title23: 'Personal Information',
  title24: 'Organizational Relationship',
  title25: 'Address',
  title26: 'Payment Information',
  title27: 'Option',
  title28: 'Proxy',
  title29: 'Guide',
  title30: 'Help',
  title31: 'Logout',
  title32: 'Are you sure you want to copy it?',
  title33: 'Add',
  title34: 'Edit',
  title35: 'Copy',
  title36: 'Delete',
  title37: 'Male',
  title38: 'Female',
  title39: 'Base Pay',
  title40: 'Periodic salary',
  title41: 'Temporary salary',
  title42: 'Save',
  title43: 'Binding device',
  title44: 'Unbinding device',
  title45: 'Set to read message',
  title46: 'Set as unread message',
  title47: 'Are you sure to create user?',
  title047: 'Become Self',
  title48: 'Export',
  title49: 'Are you sure you want to cancel the proxy?',
  title50: 'Remind',
  title51: 'Data',
  title52: 'Suspend',
  title53: 'Processing',
  title54: 'View',
  title55: 'Restart',
  title56: 'Agree',
  title57: 'Refuse',
  title58: 'Application',
  title59: 'Punch',
  title60: 'Submit application',
  title61: 'Sign',
  title62: 'Greetings',
  title63: 'Verify',
  title64: 'Modify',
  title65: 'Previous',
  title66: 'Next',
  title67: 'Single',
  title68: 'Long',
  title69: 'Job list',
  title70: 'Verification',
  title71: 'Reset Password',
  title72: 'Welcome to 2175 Cloud',
  title73: 'Setting',
  title74: 'Luttica Management System',
  title75: 'Click to set your application',
  title76: 'Modify Avatar',
  title77: 'Theme Background',
  title78: 'Basic Information',
  title79: 'Modify Email',
  title80: 'Modify Mobile',
  title81:
    'The reset email link has been sent to the mailbox. Please input the mailbox to reset the password.',
  title82: 'Add Proxy',
  title83: 'Advanced Query',
  title84: 'Security Setting',
  title85: 'Security of your current account',
  title86: 'Security Level',
  title87: 'Password Login',
  title88:
    'A password with high security can make an account safer. It is recommended that you change your password regularly and set a password that contains at least three items of capital letters, lowercase letters, numbers and special characters and is longer than 6 bits.',
  title89: 'Mailbox Binding',
  title90:
    'Mailbox binding can be used to receive Aliyun sent various systems, marketing, service notifications.',
  title91: 'Mobile Binding',
  title92: 'You have bound your cell phone.',
  title93:
    '[Your mobile phone is a secure one. You can retrieve your password, but it cannot be used for login.]',
  title94: 'You have not bound mobile, Please binding your mobile first',
  title95: 'Setting',
  title96: 'Basic Setting',
  title97: 'Send code Successfully',
  title98: 'The number of choices has reached the upper limit of 10',
  title99: 'Expand All',
  title100: 'All put away',
  title101: 'Verify failure',
  title102: 'The notification method was successfully modified',
  title103: 'Modify notification method',
  title104: 'No Attachment',
  title105: 'Total',
  title106: 'Key Positions',
  title107: 'View Employee Information',
  title108: 'View HRBP Information ',
  title109: 'Home',
  title110: 'Last',
  title111: 'Open Superior',
  title112: 'Remove Superiors',
  title113: 'Back',
  title114: 'Staff Care',
  title115: 'Onboarding Blessings',
  title116: 'Birthday Wishes',
  title117: "You're bound to a mailbox",
  title118: '[ The mailbox can be used to reset passwords and receive system notifications ]',
  title119: 'Reset email link has been sent to your mailbox, Please input your mailbox to confirm.',
  title120: 'Master Data',
  title121: 'System message notification mode cannot be cancelled!',
  title122:
    'Salary information belongs to the company confidential category, do not discuss with your colleagues in any case. If you have any questions, please contact the human resource department, thank you!',
  title123: 'Verify Password',
  title124: ' Salary Details',
  title125: 'Launch Page',
  title126: 'Pending Approval',
  title127: 'Approval Opinions ',
  title128: 'Application Details ',
  title129: 'Approval Process ',
  title130: 'Attachment',
  title131: 'Approved',
  title132: 'Approval Time',
  title133: 'No Attachments',
  title134: 'Standard Reports',
  title135: 'Self-service Reports',
  title136: 'Run',
  title137: 'Download',
  title138: 'View Information',
  title139: 'Pause Process',
  title140: 'Start Process',
  title141: 'Initiator',
  title142: 'Current page must be completed!',
  title143: 'Enter',
  title144: 'Employee multi dimensional data analysis report',
  title145: 'Organization information data analysis report',
  title146: 'User trajectory data analysis report',
  title147: 'Before',
  title148: 'After',
  title149: 'Country',
  title150: 'Province',
  title151: 'Permission Setting',
  title152: 'My Permission',
  title153: 'Allowed',
  title154: 'Not Overlap',
  title155: 'Only One',
  title156: 'Core Data',
  title157: 'Auto',
  title158: 'Manual',
  title159: 'Data Saved',
  title160: 'Filter',
  title161: 'This is a report',
  title162: 'The sum of organizational relationship percentages exceeds 100!',
  title163: 'Scheduling',
  title164: 'Personal OKR',
  title165: 'Assist OKR',
  title166: 'Enterprise Brain',
  title167: 'Salary calculation',
  title168: 'Calculation',
  title169: 'Salary calculation result',
  title170: 'Data report used for payroll payment via bank channel',
  title171: 'Check and batch download employee payroll wage type details report',
  title172: 'day',
  title173: '请选择开始时间和结束时间',
  title174: 'Evaluation',
  title175: 'Upload complete!',
  title176: 'Off',
  title177: 'On',
  title196: 'Welcome to ',
  title197: ' Platform',
  title185: 'Enrollment Registration Form',
  title190: 'Off',
  title191: 'On',
  title194: 'Workload',
  title198: 'Move',
  title199: 'Switch',
  title204: 'Employee Data',
  title205: 'Staff Attendance',
  title206: 'Move',
  title207: 'Filter Expired Data',
  title208: 'Show All Data',
  title209: 'Total Fixed Salary',
  title210: 'Filter Read Message',
  title211: 'Show All Message',
  title222: 'Login By Mobile',
  title223: 'Work Plan Scheduling',
  title224: 'Business Card Application',
  title225: 'Ticket Application',
  title226: 'Visa Application',
  title227: 'Hotel Application',
  title228: 'Express Application',
  title229: 'Visitor Registration Application',
  title230: 'Administrative Repair Application',
  title231: 'Transfer',
  title233: 'Job Assignment List',
  title234: 'Are you sure you want to delete the selected data? ',
  title235: 'Check Payslip',
  title244: 'Selected Role',
  title245: 'Import Type',
  title246: 'Enterprise WeChat login',
  title247: 'DingTalk Login',
  title248: 'Feishu Login',
  title249: 'WeChat login',
  title250: 'WeChat Binding',
  title251: 'You are bound to WeChat',
  title252: '[You can scan the code to log in to the system after binding to WeChat]',
  title253: 'You have not yet bound WeChat, please bind WeChat first',
  title254: 'Use WeChat to scan and bind 2175',
  title255: 'Enterprise WeChat binding',
  title256: 'You have bound the enterprise WeChat',
  title257: '[You can use the enterprise WeChat scan code to log in to the system]',
  title258: 'You have not yet bound the enterprise WeChat, please bind the enterprise WeChat first',
  title259: 'Use corporate WeChat to scan and bind 2175',
  title260: 'Dingding Dinding',
  title261: 'You have bound DingTalk',
  title262: '[You can use DingTalk to scan the code to log in to the system]',
  title263: 'You have not bound DingTalk yet, please bind DingTalk first',
  title264: 'Use DingTalk to sweep to bind 2175',
  title265: 'Feishu Dinding',
  title266: 'You have bound Feishu',
  title267: '[You can use Feishu to scan the code to log in to the system]',
  title268: 'You have not bound Feishu, please bind Feishu first',
  title269: 'Use Feishu to scan and bind 2175',
  title270: 'Unbind',
  title271: 'WeChat Unbinding',
  title272: 'Enterprise WeChat Unbinding',
  title273: 'DingTalk Unbind',
  title274: 'Feishu Unbinding',
  title275: 'Information Type Field',
  title276: 'Use Feishu to scan the code to log in',
  title277: 'Roast',
  title278: '2175 Cloud',
  title279: 'Quick Start',
  title280: 'Browse quick start and learn about the system right away?',
  title281: 'Task Type',
  title282: 'Unfiled',
  title283: 'Filed',
  title284: 'Archived By',
  title285: 'Archive Time',
  title286: 'DocCenter Log',
  title287: 'Upload File',
  title288: 'Upload Folder',
  title289: 'Task Daily',
  title300: 'Project',
  title301: 'Task',
  title302: 'Project Data',
  button01: 'Login',
  button02: 'Forget Password',
  button03: 'OK',
  button04: 'Today',
  button05: 'Yesterday',
  button06: 'A Week Ago',
  button07: 'Inquire',
  button08: 'Change',
  button09: 'Hire',
  button10: 'Transfer',
  button11: 'Termination',
  button12: 'Rehire',
  button13: 'Create User',
  button14: 'Import Photos',
  button15: 'Batch Operation',
  button16: 'Batch Import',
  button17: 'Batch Edit',
  button18: 'Template Download',
  button19: 'This Week',
  button20: 'This Month',
  button21: 'This Season',
  button22: 'This Year',
  button23: 'Cancel',
  button24: 'Click to Upload',
  button25: 'Shuttle Application',
  button26: 'Verify by Phone',
  button27: 'Verify by Email',
  button28: 'Code',
  button29: 'Return Home',
  button30: 'Resend',
  button31: 'Last year',
  button32: 'Start',
  button33: 'Run',
  button34: 'Confirm',
  button35: 'Initiate Signing',
  button36: 'Summit',
  button37: 'Return',
  button38: 'Confirm',
  button39: 'Send Letter',
  button40: 'Effective',
  button41: 'SystemHoliday',
  button42: 'Shift Type',
  button43: 'Break',
  button44: 'Shift',
  button45: 'HolidayType',
  button46: 'Quota Type',
  button47: 'No',
  button48: 'OK',
  button49: 'Terminated',
  button50: 'Urging',
  btnRefresh: 'Refresh',
  btnAdd: 'Add',
  btnSearch: 'Search',
  btnDel: 'Delete',
  btnCopy: 'Copy',
  btnEdit: 'Edit',
  costType: 'Cost Type',
  btnDown: 'Down',
  btnImport: 'Import',
  btnUploadFile: 'Upload File',
  btnNewFolder: 'New Folder',
  label01: 'Original Cipher',
  label02: 'New Password',
  label03: 'Repeat new Password',
  label04: 'System Information',
  label05: 'Notice by E-mail',
  label06: 'Notice by SMS',
  label07: 'Device Name',
  label08: 'New Entry',
  label09: 'Ongoing Entry',
  label10: 'Successful Entry',
  label11: 'People',
  label12: 'Load More',
  label13: 'Loaded All',
  label14: 'Default Theme',
  label15: 'Red Theme',
  label16: 'Orange Theme',
  label17: 'Brown Theme',
  label18: 'Created Date',
  label19: 'Cut-off Date',
  label20: 'Authentication',
  label21: 'Success',
  label22: ' Switch to Mobile',
  label23:
    'Use code to verify, in order to confirm the operation with you, please complete the following verification:',
  label24: 'Mobile No',
  label25: 'Switch to Email',
  label26: 'Return',
  label27: 'Account',
  label28: 'You have successfully changed your password!',
  label29: 'Changed email address successfully!',
  label30: 'New Email',
  label31: 'New Mobile',
  label32: 'Binding Mobile',
  label33: 'Bind',
  label34: 'Modify Mobile',
  label35: 'You have successfully bonded a new mobile!',
  label36: 'System Menu',
  label37: 'to',
  label38: 'Set',
  label39: 'Not set',
  label40: 'Error typing mailbox, Please input correct mailbox',
  label41: 'Sender：',
  label42: 'Rotate',
  label43: 'Preview',
  label44: 'Confirm Close',
  label45: 'Accept User Procotol is must for using 2175 Cloud, otherwise you have to logout!',
  label46: 'Submitter ',
  label47: 'The password entered is wrong, Please input the correct password',
  label48: 'Confirm the Mailbox',
  label49: 'Lunch Allowance',
  label50: 'Transport Allowance',
  label51: 'Bonus',
  label52: 'Pension',
  label53: 'Unemployment',
  label54: 'Medical',
  label55: 'Housing Provident Fund',
  label56: 'Social Security',
  label57: 'Personal income tax',
  label58: 'Subtotal',
  label59: 'Payment',
  label60: 'Deduction',
  label61: 'Real Income',
  label62: 'Quota Name',
  label63: ' Hours',
  label64: 'Imported Successfully',
  label65: 'Failed',
  label66: 'Online onboarding',
  label67: 'Offline onboarding',
  label68: 'Created successfully',
  label169: 'Chart',
  label170: 'Data',
  label171: 'Number of levels',
  label172: 'The income tax shall be paid for the whole month',
  label173: 'Tax rate',
  label174: 'Quick calculation deduction',
  label176: 'Mobile',
  label177: 'Bank',
  label178: 'Face Recognition',
  label179: 'Company Info',
  label180: 'Transaction',
  label181: 'Complete',
  label182: 'Allowance',
  label183: 'Break',
  label184: 'Day Level',
  label185: 'Shift Name',
  label186: 'Shift English Name',
  label187: 'Early Leave Tolerance(Minute)',
  label188: 'Tardiness Tolerance Time(Minute)',
  label189: 'Working Hours(Hour)',
  label190: 'Shift Type',
  label191: 'Work Plan',
  label192: 'Work Plan English',
  label193: 'Scheduling',
  label194: 'Shift',
  label195: 'Holiday Name',
  label196: 'Evaluation type',
  label197: 'Attendance Type',
  label198: 'Place',
  label199: 'Evection',
  label120: 'Photo',
  label121: 'Scope(rice)',
  label122: 'Attendance Type',
  label123: 'Shift Type English',
  label124: 'Break Name',
  label125: 'Break Name En',
  label126: 'Break Time(Hour)',
  label127: 'Pay Time(Hour)',
  label128: 'Holiday English Name',
  label129: 'Public Holiday',
  label130: 'Evaluation type English',
  label131: 'Attendance type English',
  label132: 'Attendance Type English',
  label133: 'Attendance Evaluation Sheet Name',
  label134: 'Hour Upper',
  label135: 'Hourly Wage',
  label136: 'Multiple',
  label137: 'Period',
  label138: 'Deduct Quota',
  label139: 'Mini Unit(hour)',
  label140: 'Ot Com Med',
  label141: 'Quota',
  label142: 'Round',
  label143: 'Attendance Type Name',
  label144: 'Take Photos At Work',
  label145: 'Take Photos After Work',
  label146: 'Business Trip Photography',
  label147: 'Leave Type',
  label148: 'Commed Name',
  label149: 'Leave Type English',
  label150: 'Quota English Name',
  label151: 'Commed English Name',
  label152: 'DayClass Name',
  label153: 'DayClass English Name',
  label154: 'Area',
  label155: 'Process',
  label156: 'Housing_Base_Lower',
  label157: 'Housing_Base_Upper',
  label158: 'Housing_Fund_Company',
  label159: 'Housing_Fund_Emp',
  label160: 'Injure_Company',
  label161: 'Injure_Emp',
  label162: 'Maternity_Company',
  label163: 'Maternity_Emp',
  label164: 'Medical_Company',
  label165: 'Medical_Emp',
  label166: 'Pension_Company',
  label167: 'Pension_Emp',
  label168: 'Social_Base_Lower',
  label200: 'Social_Base_Upper',
  label201: 'Supply_Housing_Fund_Company',
  label202: 'Supply_Housing_Fund_Emp',
  label203: 'Supply_Medical_Company',
  label204: 'Supply_Medical_Emp',
  label205: 'Supply_Pension_Company',
  label206: 'Supply_Pension_Emp',
  label207: 'Unemployment_Company',
  label208: 'Unemployment_Emp',
  label209: 'serial',
  label210: 'Top',
  label211: 'Bottom',
  label212: 'Rate',
  label213: 'Deduct',
  label214: 'Deduct Method',
  label215: 'Name',
  label216: 'Short Name',
  label217: 'Plus',
  label218: 'Type',
  label219: 'Cur Period',
  label220: 'First Period',
  label221: 'Retro Period',
  label222: 'Time Period',
  label223: 'Status',
  label224: 'Company',
  label225: 'Note',
  label226: 'Encrypt',
  label227: 'Serial',
  label228: 'Note English',
  label229: 'name',
  label230: 'Field Name',
  label231: 'Field En Name',
  label232: 'Unbind',
  label233: 'Pit',
  label234: 'PIT(Paid by Company)',
  label235: 'Pit refund',
  label236: 'Field Name',
  label237: 'Is Filter',
  label238: 'Filter Table',
  label239: 'cannot be modified',
  label240: 'Modifiable',
  label241: 'Editable',
  label242: 'icon',
  label243: 'type_name',
  label244: 'type_name_en',
  label245: 'Aseal',
  label246: 'Bseal',
  label247: 'template',
  label278: 'Lng',
  label279: 'Lat',
  label280: 'Scope',
  label281: 'Org Chart',
  label282: 'Org Mgr',
  label283: 'Report Line',
  label284: 'configure',
  label285: 'Description',
  label286: 'Icon',
  label287: 'Process Key',
  label288: 'Sync Proc',
  label289: 'Title',
  label290: 'Time',
  label291: 'Description En',
  label292:
    'Only the data of the last 6 months is displayed. Historical data through the search function!',
  label293: 'Description',
  label294: 'Payment Proportion',
  label295: 'Quit',
  label296: 'Module',
  label297: 'Report Form',
  label298: 'Self Service Center Approval Process',
  label299: 'Salary Group',
  label300: 'Report data',
  label301: 'Fixed Shift',
  label302: 'Dynamic Shift',
  label303: 'Development Type',
  label304: 'Chinese Name',
  label305: 'English Name',
  label306: 'Job Desc',
  label307: 'Job Group',
  label308: 'Job Handler',
  label309: 'Job Company',
  label310: 'Period',
  label311: 'Executor Param',
  label312: 'Stop',
  label313: 'Running',
  label314: 'The reset password link will be sent to this email',
  label315: 'File List',
  label316: 'New Task',
  table01: 'Name',
  table02: 'Employee ID',
  table03: 'Job',
  table04: 'Operation',
  table05: 'Department',
  table06: 'Company',
  table07: 'Start Date',
  table08: 'End Date',
  table09: 'Employee Type',
  table10: 'Personnel Area',
  table11: 'Employee Group',
  table12: 'Change Type',
  table13: 'Reason',
  table14: 'Payroll Group',
  table15: 'Remark',
  table16: 'Change Person',
  table17: 'Type',
  table18: 'City',
  table19: 'Address',
  table20: 'Telephone',
  table21: 'Subordinate',
  table22: 'Cost Center',
  table23: 'Payment',
  table24: 'Withdrawing',
  table25: 'Amount',
  table26: 'Real Income',
  table27: 'Percentage',
  table28: 'Employee Status',
  table29: 'Quota Type',
  table30: 'Group',
  table31: 'Team',
  table32: 'Theme',
  table33: 'Date',
  table34: 'Status',
  table35: 'Approver',
  table36: 'Attachment',
  table37: 'Payment Method',
  table38: 'Purpose',
  table39: 'Job',
  table40: 'Staff',
  table41: 'Proportion',
  table42: 'Name',
  table43: 'Employee ID:',
  table44: 'Department:',
  table45: 'Company',
  table46: 'Approval State',
  table47: 'Approval Comments',
  table48: 'Pending Approval',
  table49: 'Approved',
  table50: 'Payroll Grouping',
  table51: 'Current State',
  table52: 'Pay Cycle',
  table53: 'Number of pay counts',
  table54: 'Backdate Date',
  table55: 'List of Employees',
  table56: 'Note',
  table57: 'Month',
  table58: 'Change Time',
  table59: 'Previous Menu',
  table60: 'Role',
  table61: 'Accept the terms of service',
  table62: 'Start Menu',
  table63: 'Modify Reason',
  table64: 'User',
  table65: 'Job Code',
  table66: 'Role ID',
  table67: 'Supervisor Position',
  table68: 'Exclude',
  table69: 'Viewer',
  table70: 'Information Type',
  table71: 'Classification',
  table72: 'Salary Calculation Backtracking',
  table73: 'Time Evaluation Backtracking',
  table74: 'Repeat',
  table75: 'Visible To Eemployees',
  table76: 'Field ID',
  table77: 'Field Name',
  table78: 'Production Mechanism',
  table79: 'Interval',
  table80: 'Current Employee ID',
  table81: 'Length',
  table82: 'Template',
  table83: 'Term',
  table84: 'Route',
  table85: 'Legal Person',
  table86: 'Project Manager',
  table87: 'Job',
  table88: 'Job Description ',
  table89: 'Abbreviation ',
  table90: 'Full Name',
  table91: 'Approval Process',
  table92: 'Encryption ',
  table93: 'First Cycle',
  table94: 'Current Cycle',
  table95: 'Head',
  table96: 'Tail',
  table97: 'Effective Date',
  table98: 'Expiration Date',
  table99: 'Exception type',
  table100: 'Abnormal content',
  table101: 'Serial Number',
  table102: 'Total number of people',
  table103: 'Total wages should be paid',
  table104: 'Total actual salary',
  table105: 'Subscriber',
  table106: 'Area',
  table107: 'Year',
  table110: 'Shift Time',
  table111: 'Working Hour',
  table112: 'Late',
  table113: 'Leave Early',
  table114: 'Absenteeism',
  table115: 'Lack of Clock In/Out',
  table116: 'Absence',
  table117: 'Sick',
  table118: 'Workday Overtime',
  table119: 'Holiday Overtime',
  table120: 'Public Holiday Overtime',
  table121: 'Overtime Compensate',
  table122: 'Overtime Abnormal',
  table123: 'Template',
  table124: 'Company',
  table125: 'Type',
  table126: 'Change Time',
  table127: 'Contract Name',
  table128: 'Company',
  table129: 'Authorizer',
  table130: 'Default Authorizer',
  table131: 'No. of Attendance Employees',
  table132: 'Actual No. of Attendance Employees',
  table133: 'Attendance Hours',
  table134: 'Actual Attendance Hours',
  table135: 'No. of Overtime Employees',
  table136: 'Overtime Hours',
  table137: 'No. of Leave Employees',
  table138: 'No. of Leave Hours',
  table139: 'No. of Absenteeism Employees',
  table140: 'Absenteeism Hours',
  table141: 'No. of Late Employees',
  table142: 'No. of Leave Early Employees',
  table143: 'Late Hours',
  table144: 'Leave Early Hours',
  table145: 'No. of Absence Employees',
  table146: 'Absence Hours',
  table147: 'Sick Hours',
  table148: 'Shift Allowance',
  table149: 'No. of Sick Employees',
  table150: 'Blacklist',
  table151: 'Number Of Contracts',
  table152: 'Signed Contracts',
  table154: 'TenantId',
  table155: 'Self Authorization',
  table158: 'Shift Time',
  table184: 'Other Deduction',
  table185: 'Payroll Tax',
  table186: 'Provident Fund',
  table187: 'Social Security',
  table188: 'Payroll',
  table205: 'Shift Hour',
  table206: 'English Name',
  table208: 'Basic Infomation Verification',
  table209: 'Legal Person Verification',
  table210: 'Create Sign Account',
  table211: 'Complete',
  table212: 'Payment Account Verification',
  table213: 'Payment Amount Verification',
  table214: 'Code Verification',
  table215: 'urgent',
  table216: 'transferee',
  table217: 'Attendance should be (H)',
  table218: 'Fixed salary (CNY)',
  table219: 'Usually work overtime (H)',
  table220: 'Weekend overtime (H)',
  table221: 'National holiday overtime (H)',
  table222: 'Absence Deduction (H)',
  table223: 'Complete attendance award (CNY)',
  table224: 'Travel allowance (CNY)',
  table225: 'Reward and punishment (CNY)',
  table226: '2175 Cloud Enterprise WeChat Binding',
  table227: 'Personal leave (H)',
  table228: 'Sick leave (H)',
  table229: 'Personal leave (H)',
  table230: 'Sick leave (H)',
  table231: 'Actual attendance (H)',
  table232: 'Meal allowance (CNY)',
  table233: 'Deduction for absence (CNY)',
  table234: 'Wages payable (CNY)',
  table235: 'Social security (CNY)',
  table236: 'Provide Fund (CNY)',
  table237: 'Individual tax (CNY)',
  table238: 'Actual salary (CNY)',
  table239: 'absenteeism (CNY)',
  table240: 'Overtime pay (CNY)',
  table241: 'Onboarding Documents',
  table242: 'Time Sheet',
  table243: 'Currency type',
  table244: 'Rule Type',
  table245: 'Supplier Type',
  table246: 'No.',
  table247: 'File Name  ',
  table248: 'Open Time',
  table249: 'Close Time',
  table251: 'Attendance days',
  table252: 'Overtime attendance (usual)',
  table253: 'Overtime attendance (weekend)',
  table254: 'Overtime attendance (national holiday)',
  table255: 'compensatory leave (H)',
  table256: 'Absence (H)',
  table257: 'Bereavement leave (H)',
  table258: 'Paid sick leave (H)',
  table259: 'Other paid leave (H)',
  table260: 'Regular attendance',
  table261: 'Annual leave (H)',
  table262: 'Class',
  table263: 'Rest',
  table250: 'Job Content',
  table288: 'Directory',
  table264: 'Should Attendance',
  table265: 'Actual Attendance',
  table266: 'Clock In',
  table267: 'Clock Out',
  table268: 'In Approval',
  table269: 'Leave & Out',
  table270: 'Employee Confirmed',
  table271: 'Line Number',
  table272: 'Other Types Of Leave',
  table273: 'Paid Sick Leave',
  table274: 'Annual Leave',
  form01: 'Employee ID',
  form02: 'Name',
  form03: 'Identity ID',
  form04: 'Gender',
  form05: 'Birthday',
  form06: 'Nation',
  form07: 'Native Place',
  form08: 'Political Outlook',
  form09: 'Marital Status',
  form10: 'User Name',
  form11: 'Mailbox',
  form12: 'Mobile Phone',
  form13: 'Recruitment Channels',
  form14: 'Remark',
  form15: 'Last Modifier',
  form16: 'Bank',
  form17: 'Card Number',
  form18: 'Work Plan',
  form19: 'Evaluation Type',
  form20: 'Job ID',
  form21: 'Payroll Group',
  form22: 'Rank',
  form23: 'Amount',
  form24: 'Unit',
  form25: 'Relationship',
  form26: 'Contract Type',
  form27: 'Educate Type',
  form28: 'College',
  form29: 'Major',
  form30: 'Graduated',
  form31: 'Degree',
  form32: 'Highest Degree',
  form33: 'Skill',
  form34: 'Level',
  form35: 'Date',
  form36: 'Quantity',
  form37: 'Unit',
  form38: 'Borrow Date',
  form39: 'Return Date',
  form40: 'Returned',
  form41: 'Time Cost',
  form42: 'Industry',
  form43: 'Development Project',
  form44: 'Development Path',
  form45: 'Partner Name',
  form46: 'Partner Type',
  form47: 'Degree',
  form48: 'Certificate',
  form49: 'Time Evaluate Date',
  form50: 'Time Retro Date',
  form51: 'Time Retro Date',
  form52: 'Payroll Retro Date',
  form53: 'Locked',
  form54: 'Locked Date',
  form55: 'Schedule',
  form56: 'Evaluate Type',
  form57: 'Employees ID',
  form58: 'Address Type',
  form59: 'Compensate Method',
  form61: 'Shift Date',
  form62: 'Shift Reason',
  form63: 'Shift',
  form64: 'Type',
  form65: 'Leave',
  form66: 'Quota',
  form67: 'Deduction Start Date',
  form68: 'Deduction End Date',
  form69: 'Allocated Quantity',
  form70: 'Deduction Amount',
  form75: 'Reason',
  form76: 'Quota',
  form77: 'Time',
  form78: 'Location',
  form79: 'Type',
  form80: 'Date of Payment',
  form81: 'Salary',
  form82: 'Card Name',
  form83: 'Nationality',
  form84: 'Relative Name',
  form85: 'Emergency Contact',
  form86: 'Status',
  form87: 'Raise Scale',
  form88: 'Raise Amount',
  form89: 'Package',
  form90: 'Description',
  form91: 'Supplier',
  form92: 'Mealtime',
  form93: 'Code',
  form94: 'Vehicle Type',
  form95: 'Return Date',
  form96: 'Return Date',
  form97: 'Number of People',
  form98: 'Job Responsibilities',
  form99: 'Job Requirements',
  form100: 'Hope Arrival Date',
  form101: 'Entry Method',
  form102: 'Positive Date',
  form103: 'Trial Period Summary',
  form104: 'Target Position',
  form105: 'Reason for Transfer',
  form106: 'Adjustment Date',
  form107: 'Reason',
  form108: 'Last Working Day',
  form109: 'Payment by',
  form110: 'Payment Object',
  form111: 'Bank',
  form112: 'Account',
  form113: 'Use',
  form114: 'Description',
  form115: 'Print Date',
  form116: 'File Name',
  form117: 'File Type',
  form118: 'Stamp Type',
  form119: 'Specification',
  form120: 'Price',
  form121: 'Contract No.',
  form122: 'Signing Date',
  form123: 'Contracted Unit',
  form124: 'Contract Terms',
  form125: 'Project Name',
  form126: 'Project Description',
  form127: 'Project Purpose',
  form128: 'Start Date',
  form129: 'Staffing Needs',
  form130: 'Funding Needs',
  form131: 'Validation Results',
  form132: 'Duration',
  form133: 'Correction Method',
  form134: 'Correction Reason',
  form135: 'Date Time',
  form136: 'Bonus Type',
  form137: 'Effective Date',
  form138: 'Employee ID',
  form139: 'Does not Exist',
  form140: 'Customer number does not exist',
  form141: 'Your password is too short',
  form142:
    'Contain at least 3 of numbers, uppercase, lowercase and special character, and not less than 6 characters.',
  form143: 'Photo',
  form144: 'Retirement',
  form145: 'Correction Method',
  form146: 'Leave Time',
  form147: 'Overtime Hours',
  form148: 'Compensation Method',
  form149: 'Correction Time',
  form150: 'Boarding Route',
  form151: 'Boarding Point',
  form152: 'Getting Off',
  form153: 'Needs Time',
  form154: 'Is the drop off point the same?',
  form155: 'Getting off the route',
  form156:
    'Password restrictions: uppercase, lowercase, number, and special symbols satisfy three, and the length is not less than 6 digits.',
  form157: 'The Email is not your Email',
  form158: 'Upload',
  form159: 'Source',
  form160: 'Remaining Amount',
  form161: 'Intelligent Customer Service',
  form162: 'Payroll Status',
  form163: 'Employee Salary',
  form164: 'Periodic Salary',
  form165: 'Aperiodic Salary',
  form166: 'Current State',
  form167: 'Times of Salary Calculation',
  form168: 'Time Allocation',
  form169: 'Consumed',
  form170: 'Company Authorization ',
  form171: 'Employee  Authorization ',
  form172: 'Date',
  form173: 'Decimal Places',
  form174: 'Rule',
  form175: 'Employee Editable',
  form176: 'Approval',
  form177: 'SubTotal',
  form178: 'Information',
  form179: 'Warning',
  form180: 'Error',
  form183: 'Type of tax payment',
  form184: 'Tax payment area',
  form185: 'Exempt number',
  form186: 'Tax Band',
  form187: 'Tax payment mode',
  form188: 'Deduction method',
  form189: 'Special deduction',
  form190: 'Date of loan',
  form191: 'Loan labor number',
  form192: "Borrower's name",
  form193: 'Loan amount',
  form194: 'Payment unit',
  form195: 'reason for borrowing',
  form196: 'Reason for application',
  form197: 'Apply for a position',
  form198: 'job requirements',
  form199: 'Estimated time of arrival',
  form200: 'Five Insurance type',
  form201: 'Received manual number',
  form202: 'Original loan',
  form203: 'The balance should be refunded',
  form204: 'Whether to occupy the department fee limit',
  form205: 'Name of payee',
  form206: 'Total',
  form207: 'Payment Company',
  form208: 'Manager',
  form209: 'Payment Purpose',
  form210: 'Payee unit',
  form211: 'Associated customer',
  form212: 'Account Bank',
  form213: 'Target',
  form214: 'Behavior',
  form215: 'Total Score',
  form216: 'Clock Sheet',
  form217: 'Time Sheet',
  form218: 'Days',
  form219: 'Business Trip',
  form220: 'Departure City',
  form221: 'Destination City',
  form222: 'Companion',
  form223: 'Reason for going out',
  form224: 'Reason',
  form225: 'Template Contract',
  form226: 'Supplier Mailbox',
  form227: 'Supplier Mobile Phone',
  form228: 'Annual Performance',
  form229: 'Semi-annual Performance',
  form230: 'Quarterly performance',
  form231: 'Monthly Performance',
  form232: 'Other Performance',
  form233: 'Duration (days)',
  form234: 'Summary of Kpi Assessment in Probation Period',
  form235: 'Template Contract',
  form236: 'Pit refund',
  form241: 'Housing Fund(Employee)',
  form242: 'Social Insurance(Employee)',
  form243: 'Social Insurance(Company)',
  form244: 'Housing Fund(Company)',
  form245: 'Past Payable Tax Income',
  form246: 'Attendance Rate',
  form247: 'Process',
  form248: 'Minimum Quantity',
  form249: 'Quantity limit',
  form250: 'Piece Unit Price',
  form251: 'Postponed To',
  form252: 'Course Title',
  form253: 'Training Method',
  form254: 'Training Fees',
  form255: 'Training Location',
  form256: 'Training Content',
  form257: 'Training Reason',
  form258: 'Training Expectations',
  form259: 'Time Evaluation Sheet',
  timeEvaluationTitleTemplate:
    '{year}-{month} Time Evaluation Sheet(Time Period:{startMonth}-{startDay} to {endMonth}-{endDay})',
  form260: 'Business Trip Location',
  form261: 'Updated On',
  form262: 'Borrower',
  form263: 'Instructions For Use',
  form264: 'Repayment',
  form265: 'Application Content',
  form266: 'Specific Details',
  form267: 'Budget Amount (CNY)',
  form268: 'Transfer Out Department',
  form269: 'Transfer Out Date',
  form270: 'Asset Number',
  form271: 'Asset Name',
  form272: 'Transfer Reason',
  form273: 'Receiving Department',
  form274: 'Receiver',
  form275: 'Asset Model',
  form276: 'Purchase Department',
  form277: 'Buyer',
  form278: 'Contact Information',
  form279: 'Specification',
  form280: 'Amount (CNY)',
  form281: 'Department',
  form282: 'Date of Application',
  form283: 'Note Department',
  form284: 'Sign The Subject',
  form285: 'Signed Content',
  form286: 'Asset Class',
  form287: 'Truncate Original Tissue',
  form288: 'Move Date',
  form289: 'Applicant (Chinese)',
  form290: 'Applicant (English)',
  form291: 'Mobile Number',
  form292: 'Email',
  form293: 'Number of application card boxes',
  form294: 'Reason',
  form295: 'Number of seals',
  form296: 'item number',
  form297: 'Flight Crew',
  form298: 'Flight department',
  form299: 'Flight ID number',
  form300: 'Contact information',
  form301: 'Travel Date',
  form302: 'Origin',
  form303: 'Destination',
  form304: "Administrator's name",
  form305: 'Management department',
  form306: 'Visa place',
  form307: 'Visa Type',
  form308: 'Travel time',
  form309: 'stay date',
  form310: 'Reason for accommodation',
  form311: 'Standard of accommodation',
  form312: 'Recipient',
  form313: 'Receiving company',
  form314: 'Receiving company address',
  form315: 'item number',
  form316: 'Express tracking number',
  form317: 'Interview Notes',
  form318: 'Visitor Name',
  form319: 'Visitor Unit',
  form320: 'Visitor type',
  form321: 'Visitor license plate',
  form322: 'Receptionist',
  form323: "Receptionist's phone number",
  form324: 'Estimated time of arrival',
  form325: 'Repair report',
  form326: 'kilometers',
  form327: 'Job Title',
  form328: 'Date of Birth',
  form329: 'Level',
  form330: 'skill',
  form331: 'Probationary salary',
  form332: 'Saturday overtime allowance',
  form333: 'Performance bonus',
  form334: 'Management Allowance',
  form335: 'Skill Allowance',
  form336: 'Accommodation subsidy',
  form337: 'Telephone subsidy',
  form338: 'Attendance bonus',
  form339: 'Employee monthly salary',
  form340: 'CC',
  form341: 'Position',
  form342: 'Line',
  form343: 'Site',
  form344: 'User',
  form345: 'Number of copies',
  form346: 'Approved by',
  form347: 'Supervisor',
  form348: 'Stamp content',
  form349: 'Applicant Position',
  form350: 'Equipment number',
  form351: 'Model',
  form352: 'Device Location',
  form353: 'Repair Reason',
  form354: 'Opinions Of The Requesting Department',
  form355: 'Maintenance Unit',
  form356: 'Repair Or Replace Unit',
  form357: 'Applicant Title',
  form358: 'Reason For Payment',
  form359: 'Payment Amount (CNY)',
  form360: 'Payment Method',
  form361: 'Payee',
  form362: 'Bank Account',
  form363: 'Training Format',
  form364: 'Training Institution',
  form365: 'Training Machine Class',
  form366: 'Reason For Application',
  form367: 'Stamp Name',
  form368: 'Custody Department',
  form369: 'Engraved By',
  form370: 'Seal Specialist',
  form371: 'Seal Purpose',
  form372: 'Stamp Retention Sample',
  form373: 'Model/Specification',
  form374: 'Unit price',
  form375: 'Delivery date',
  form376: 'Total',
  form377: 'Applicant Department',
  form378: 'Number of attachments',
  form379: 'Department/Position',
  form380: 'Annual leave days',
  form381: 'Fake code',
  form382: 'Job Agent',
  form383: 'Requestor',
  form384: 'Signature Of Person In Charge',
  form385: 'Maintenance Cost',
  form386: 'Repair Or Replace Parts And Components',
  form387: 'Personnel Administrative Opinions',
  form388: 'Signature Of Handler',
  form389: 'Advance Travel Expenses',
  form390: 'Amount In Words',
  form391: 'ID',
  form392: 'Cancelled Holidays',
  form392_1: 'Cancelled Business Trip',
  form393: 'Reason for Cancellation',
  form394: 'Republish',
  form395: 'Using Time',
  form396: 'Approval Type',
  form397: 'Direct Employees',
  form398: 'Indirect Employees',
  form399: 'Sick Leave Days',
  form400: 'Leave Of Absence Days',
  form401: 'Night Shift Days',
  form402: 'Annual Leave Days',
  form403: 'Meal Supplement',
  form404: 'Holiday',
  form405: 'Total Overtime',
  form406: 'Forgot To Clock In Times',
  form407: 'Total Working Hours',
  form408: 'go to work',
  form409: 'leave work',
  form410: 'Project',
  form411: 'Task',
  form412: 'Working Hours',
  form413: 'Working Total',
  form414: 'Reporter',
  form415: 'Reporter Date',
  form416: 'Working hours',
  form417: 'Plan Start',
  form418: 'Plan End',
  form419: 'Act. Start',
  form420: 'Act. End',
  form421: 'Reason For Borrowing',
  form422: 'Enter',
  form423: 'Loan Method',
  form424: 'Payee name',
  form425: 'Bank Account',
  form426: 'Payment',
  form427: 'Payment Date',
  form428: 'Related Application',
  form429: 'Abstract',
  form430: 'Total',
  form431: 'Type',
  form432: 'Reason',
  form433: 'Car',
  form434: 'Location (from)',
  form435: 'Location (to)',
  form436: 'Train',
  form437: 'Aircraft',
  form438: 'Accommodation Fee',
  form439: 'Travel Subsidy',
  form440: 'Total Amount',
  form441: 'Total Amount',
  form442: 'Invoice Issuing Unit',
  form443: 'Offset Expense Type',
  form444: 'Apply Reason',
  form445: 'Expected delivery date',
  form446: 'Name',
  form447: 'Model or Specification',
  form448: 'Salary',
  form449: 'Department after change',
  form450: 'Post change position',
  form451: 'Salary after change',
  form452: 'Reason for change explanation',
  form453: "Employee's personal opinion",
  form454: 'Reason for using seal',
  form455: 'Number of file copies',
  form456: 'Direct superior',
  form457: 'Graduation School',
  form458: 'Employment salary',
  form459: 'Proposed reporting date',
  form460: 'Recruitment position',
  form461: 'Recruitment Department',
  form462: 'Requirement type',
  form463: 'Number of recruiters',
  form464: 'Reason for using the vehicle',
  form465: 'Vehicle type',
  form466: 'Vehicle usage duration',
  form467: 'Destination of vehicle',
  form468: 'Attached probationary period assessment form',
  form469: 'Resignation type',
  form470: 'Business Travel Fee',
  form482: 'Submission time',
  form483: 'Current approval status',
  form484: 'Approval node',
  form485: 'Operation record',
  form486: 'Changhuo Microbiology',
  form487: 'Approval number',
  form488: 'Print date',
  form489: 'Printed by',
  form490: 'Verified by',
  form491: 'Reimburser',
  form492: 'Reimbursement details',
  form493: 'Project Daily',
  form494: 'Payment Request',
  form495: 'Business Reimbursement',
  form496: 'Cost Reimbursement',
  form497: 'Offsetting Accounts',
  form498: 'Price with VAT',
  form499: 'VAT Rate',
  form500: 'Total',
  form501: 'Photo',
  form502: 'Save',
  form503: 'Get saved draft',
  form504: 'Purchase Order',
  form505: 'Created Order',
  form506: 'No order created',
  form507: 'Appointment Code',
  form508: 'Visiting Reason',
  form509: 'Respondent',
  form510: 'Guider',
  form511: 'Type of Vehicles',
  form512: 'NO. of Vehicles',
  form513: 'No. of Passengers',
  form514: 'Single Pass Distance',
  form515: 'Visiting Time',
  form516: 'Visitor Invitation',
  form517: 'Send appointment code',
  form518: 'pending',
  form519: 'ongoing',
  form520: 'complete',
  form521: 'cancel',
  form522: 'CE',
  form523: 'NEU',
  form524: 'Visiting Unit',
  form525: "Visitor's Name",
  form526: 'Type of Vehicles(ICE/NEU)',
  form527: 'Public Transportation',
  form528: 'Private Car',
  form529: 'Invitation Code',
  form530: 'Reimbursement Company',
  form531: 'Performance Allowance Base',
  form532: 'Adjustment',
  form533: 'Final Score',
  form534: 'Final Performance Allowance',
  form535: 'Vacation Days',
  form536: 'Degree of Injury',
  form537: 'Injury Degree',
  form538: 'Medical Expenses',
  form539: 'Place',
  form540: 'Details of The Incident',
  form541: 'Root Cause Analysis',
  form542: 'Responsible People',
  form543: 'Rectification Suggestions',
  form544: 'Rectification Measures and Deadline for Completion of Rectification',
  form545: 'Follow Up',
  form546: 'Rectification Evidence',
  form547: 'Security Incidents Records',
  form548: 'Salary Range',
  form549: 'Resignation Approval',
  recruitResignOrderLabel: "{name}'s resignation {date}",
  form554: 'Required Position',
  form550: 'Training Type',
  form551: 'Training Name',
  form552: 'Training Purpose',
  form558: 'Event Description',
  form559: 'Root Cause Analysis',
  form560: 'Corrective Measures',
  form561: 'Completion Time',
  form562: 'Event Type',
  form563: 'Location of Occurrence',
  form564: 'Hazard Description',
  form565: 'Photos Before Rectification',
  form566: 'Photos After Rectification',
  form567: 'Planned Completion Time',
  form568: 'Rectification Completion Time',
  form569: 'Responsible Person',
  form570: 'Business Card Application',
  form571: 'English Name',
  form572: 'Job English Name',
  form573: 'Repair Location',
  form575: 'Office Phone',
  form576: 'Mobile Phone',
  placeholder01: 'Search',
  placeholder02: 'Name',
  placeholder03: 'Password',
  placeholder04: 'Code',
  placeholder05: 'Customer Code',
  placeholder06: 'Please input correct your mailbox.',
  placeholder07: 'New password',
  placeholder08: 'Confirm new password',
  placeholder09: 'Please input correct your name.',
  placeholder10: 'Please input correct the telephone.',
  placeholder11: 'Please input correct the mailbox',
  placeholder12: 'Please input correct contents',
  placeholder13: 'Please input correct the original password',
  placeholder14: 'Please input correct device name',
  placeholder15: 'Please choose proxy.',
  placeholder16: 'Please choose start time.',
  placeholder17: 'Please choose end time.',
  placeholder18: 'Please select employee id.',
  placeholder19: 'Please select departments.',
  placeholder20: 'Please select a company',
  placeholder21: 'Please input correct employee id.',
  placeholder22: 'Please input correct your ID card.',
  placeholder23: 'Please choose gender.',
  placeholder24: 'Please choose birthday.',
  placeholder25: 'Please import ethnic groups.',
  placeholder26: 'Please import your native place.',
  placeholder27: 'Please input correct political outlook.',
  placeholder28: 'Please choose marital status.',
  placeholder29: 'Please input your username',
  placeholder30: 'Please input your phone number',
  placeholder31: 'Please input recruitment channels',
  placeholder32: 'Please input correct remarks',
  placeholder33: 'Please input correct bank',
  placeholder34: 'Please input correct card number',
  placeholder35: 'Please select type',
  placeholder36: 'Please input correct City',
  placeholder37: 'Please input correct address',
  placeholder38: 'Please input correct company',
  placeholder39: 'Please input employee type',
  placeholder40: 'Please input correct personnel area',
  placeholder41: 'Please input correct employee group',
  placeholder42: 'Please input your post',
  placeholder43: 'Please input correct type of transaction',
  placeholder44: 'Please input correct the cause of transaction',
  placeholder45: 'Please input correct the payroll group',
  placeholder46: 'Please choose the time',
  placeholder47: 'Please choose the city type',
  placeholder48: 'Please choose the percentage',
  placeholder49: 'Please select a relationship type',
  placeholder50: 'Please select the industry',
  placeholder51: 'Please select a position',
  placeholder52: 'Please select a development project',
  placeholder53: 'Please choose a development path',
  placeholder54: 'Please select a partner type',
  placeholder55: 'Please choose a partner',
  placeholder56: 'Please select a partner name',
  placeholder57: 'Please select the shift date',
  placeholder58: 'Please input correct the shift reason',
  placeholder59: 'Please select a shift',
  placeholder60: 'Please select a holiday type',
  placeholder61: 'Please input the reason for leave',
  placeholder62: 'Please select a quota',
  placeholder63: 'Please select a deduction start date',
  placeholder64: 'Please select a deduction end date',
  placeholder65: 'Please input correct a deduction allocated quantity',
  placeholder66: 'Please input correct a deduction amount',
  placeholder67: 'Please input the amount（CNY）',
  placeholder68: 'Please select a unit',
  placeholder69: 'Please input the quantity',
  placeholder70: 'Please select a start date',
  placeholder71: 'Please select an end date',
  placeholder72: 'Please select employee status',
  placeholder73: 'Employee does not exist',
  placeholder74: 'Please input correct card name',
  placeholder75: 'Please select nationality',
  placeholder76: 'Please select education degree',
  placeholder77: 'Please input correct school',
  placeholder78: 'Please input a major',
  placeholder79: 'Please select grade',
  placeholder80: 'Please choose to get the date',
  placeholder90: 'Please input a work plan',
  placeholder91: 'Please input an evaluation type',
  placeholder92: 'Please input a name',
  placeholder93: 'Please input the organization',
  placeholder94: 'Please select a position',
  placeholder95: 'Please select a rank',
  placeholder96: 'Please choose a place to work',
  placeholder97: 'Please select a cost center',
  placeholder98: 'Please select the dotted line report',
  placeholder99: 'Please select a key position',
  placeholder100: 'Please select an organization category',
  placeholder101: 'Please select a category',
  placeholder102: 'Your time is less than the initial start time',
  placeholder103: 'Your time is greater than the initial end time',
  placeholder104: 'This node has been deleted',
  placeholder105: 'There are child nodes under this node, please delete them step by step.',
  placeholder106:
    "Can't directly add new employees, you can add new employees under employee management",
  placeholder107:
    'There are already employees under this position. Please choose another position.',
  placeholder108:
    'You can only select one position for the current position of the dotted line to report the position, please re-select',
  placeholder109: 'Please select the type you want to add/modify',
  placeholder110: 'Please input an id',
  placeholder111: 'No new positions or organizations under the position',
  placeholder112: 'You can only select one employee to assign, please re-select',
  placeholder113: 'You can only select one employee to delete, please re-select',
  placeholder114: 'Please select the entry date',
  placeholder115: 'Please upload attachments',
  placeholder116: 'Please select a status',
  placeholder117: 'Please adjust the ratio',
  placeholder118: 'Please select a package type',
  placeholder119: 'Please select a model',
  placeholder120: 'Please select the date of the car',
  placeholder121: 'Please choose the date of return',
  placeholder122: 'Please input the correct code',
  placeholder123: 'Please select mealtime',
  placeholder124: 'Please input the correct leadership position',
  placeholder125: 'Please adjust the number of people required',
  placeholder126: 'Please choose job responsibilities',
  placeholder127: 'Please select a job requirement',
  placeholder128: 'Please select the date of arrival',
  placeholder129: 'Please choose the way to join',
  placeholder130: 'Please select the correct date',
  placeholder131: 'Please input a correct trial period summary',
  placeholder132: 'Please select the target position',
  placeholder133: 'Please input the correct reason for the transfer',
  placeholder134: 'Please select the date of the transfer',
  placeholder135: 'Please fill in the reasons for leaving',
  placeholder136: 'Please select the last working date',
  placeholder137: 'Please input the correct payment method',
  placeholder138: 'Please input the correct purpose',
  placeholder139: 'Please select a date',
  placeholder140: 'Please input the correct payment reason',
  placeholder141: 'Please input the correct payment object',
  placeholder142: 'Please select a payment date',
  placeholder143: 'Please input the correct bank',
  placeholder144: 'Please input the correct account',
  placeholder145: 'Please input the correct use',
  placeholder146: 'Please input the correct description',
  placeholder147: 'Please select the date to print',
  placeholder148: 'Please input the correct file name',
  placeholder149: 'Please select a file type',
  placeholder150: 'Please select the stamp type',
  placeholder151: 'Please input the correct specifications',
  placeholder152: 'Please input the correct contract number',
  placeholder153: 'Please input the correct date of the contract',
  placeholder154: 'Please input the correct contracting unit',
  placeholder155: 'Please input the correct contract terms',
  placeholder156: 'Please select the contract type',
  placeholder157: 'Please input the correct project name',
  placeholder158: 'Please input the correct project description',
  placeholder159: 'Please input the correct project purpose',
  placeholder160: 'Please input the correct start date',
  placeholder161: 'Please input the correct personnel requirements',
  placeholder162: 'Please input the correct funding requirements',
  placeholder163: 'Please choose the correction method',
  placeholder164: 'Please select date and time',
  placeholder165: 'Please input the correct correction reason',
  placeholder166: 'Please select the bonus type',
  placeholder167: 'Please input the correct greeting',
  placeholder168: 'Please input the correct overtime cause',
  placeholder169: 'Please select route',
  placeholder170: 'Please choose the pick-up point',
  placeholder171: 'Please select the drop off point',
  placeholder172: 'Please input the correct mobile phone number',
  placeholder173: 'Code',
  placeholder174: 'Email address',
  placeholder175: 'Description',
  placeholder176: 'Please input',
  placeholder177: 'Please input user password',
  placeholder178: 'Please select source',
  placeholder179: 'Please select the employee id',
  placeholder180: 'Please input the post',
  placeholder181: 'please input the count',
  placeholder182: 'Please select the correct key job',
  placeholder183: 'Please input the number of people required',
  placeholder184: 'Please input Approval opinions',
  placeholder185: 'Please input the message you want to send',
  placeholder186: 'Please input your password',
  placeholder187: 'Please input the correct password',
  placeholder188: 'Please select the current state',
  placeholder189: 'Please select the payroll cycle',
  placeholder190: 'Please select the number of pay counts',
  placeholder191: 'Please select the month',
  placeholder192: 'Please select a salary item',
  placeholder193: 'Please select the organization',
  placeholder194: 'Start date cannot be later than the end time',
  placeholder195: 'End date cannot be earlier than start date',
  placeholder196: 'Please choose a compensation method',
  placeholder197: 'The date of return cannot be earlier than the date of the loan',
  placeholder198: 'Please input the pay increase ratio',
  placeholder199: 'The current date needs to be between the original start date and the end date',
  placeholder200: 'Please select the certification time',
  placeholder201: 'Please choose the authentication method',
  placeholder202: 'Please select the Employee  Authorization method',
  placeholder203: 'Please click to verify',
  placeholder204: 'Please input the name of the organization',
  placeholder205: "Please input the organization's id number",
  placeholder206: "Please input the legal person's name",
  placeholder207: 'Please input the legal person ID number',
  placeholder208:
    'Please input the name of the head office of the opening bank for the public account',
  placeholder209: 'Please input the name of the province in which the public account is located',
  placeholder210: 'Please input the name of the city where the account is located',
  placeholder211: 'Please input the full name of the branch of the public account opening bank',
  placeholder212: 'Please input the amount received',
  placeholder213: 'Please choose the type of registration',
  placeholder214: 'Please select the type of business registration',
  placeholder215: 'Please select the unit type',
  placeholder216: 'Please select a contract template',
  placeholder217: 'Please choose the drop-off point',
  placeholder218: "Please input the agent's name",
  placeholder219: 'Please input the id',
  placeholder220: 'Please input the name',
  placeholder221: 'Please choose a language',
  placeholder222: 'Please input the id or name',
  placeholder223: 'Please select HRBP',
  placeholder224: 'The end date cannot be earlier than the parent start date',
  placeholder225: 'Please select the correct timing task',
  placeholder226: 'Please select the correct Cycle',
  placeholder227: 'Please input days in advance',
  placeholder228: 'Please input the correct company',
  placeholder229: 'Please input the correct number',
  placeholder230: 'Please select the correct date of loan',
  placeholder231: 'Please select the correct proficiency',
  placeholder232: 'Please select the correct assessment type ',
  placeholder233: 'Please select the correct work plan',
  placeholder234: 'Please select the correct compensation mode',
  placeholder235: 'Please input the correct unit',
  placeholder236: 'Please input the correct price',
  placeholder237: ' Please select shift date',
  placeholder238: 'Please input the correct returned amount',
  placeholder239: 'Please input required time',
  placeholder240: 'Return date cannot be earlier than vehicle use date',
  placeholder241: 'Please select the correct previous menu',
  placeholder242: 'Please select the correct Menu',
  placeholder243: 'The amount deducted shall not be greater than the total quantity',
  placeholder244: 'Please select the correct departure date',
  placeholder245: 'Please input name',
  placeholder246: 'Please select the correct country',
  placeholder247: 'Please input sort',
  placeholder248: 'Please select the correct province',
  placeholder249: 'Please select the correct rule',
  placeholder250: 'Please input decimal places ',
  placeholder251: 'Please input type',
  placeholder252: 'Please input telephone number',
  placeholder253: 'Please select the correct notification method ',
  placeholder254: 'Please select the correct reason for modification ',
  placeholder255: 'Please select the correct role',
  placeholder256: 'Please select the correct start menu',
  placeholder257: 'Please input proportion of salary adjustment ',
  placeholder258: 'Please input the correct roles ID',
  placeholder259: 'Please input route',
  placeholder260: 'Please select the correct template',
  placeholder261: 'Please input legal person name',
  placeholder262: 'Please select the correct person in charge',
  placeholder263: 'Please select the correct job',
  placeholder264: 'Please input job description',
  placeholder265: 'Please input abbreviation',
  placeholder266: 'Please input the correct full name ',
  placeholder267: 'Please select the correct approval process ',
  placeholder268: 'Please select the correct supplier',
  placeholder269: 'Please input exchange rate',
  placeholder270: 'Please select the correct currency',
  placeholder271: 'Please input first cycle',
  placeholder272: 'Please input current cycle',
  placeholder273: 'Please input retrospective date',
  placeholder274: 'Please input amount of money',
  placeholder275: ' The end date cannot be later than the current date',
  placeholder276: ' The end date cannot be earlier than the current date',
  placeholder277: 'Please input head of job id number',
  placeholder278: 'Please input tail of job id number',
  placeholder279: 'Please input interval',
  placeholder280: 'Please input current employee id ',
  placeholder281: 'Please input length',
  placeholder282: 'Please select the correct production mechanism ',
  placeholder283: 'Please select the correct user',
  placeholder284: 'The truncation date cannot be later than the end date',
  placeholder285: 'Please input phone number',
  placeholder286: 'please input your email',
  placeholder287: 'Please input a description',
  placeholder288: 'Please select the correct check-in address',
  placeholder289: 'Please select start time and end time！',
  placeholder290: 'Please input a positive integer of 8 digits or less',
  placeholder292: 'Please select the type of tax payment',
  placeholder293: 'Please select the tax payment area',
  placeholder294: 'Please select the tax payment mode',
  placeholder295: 'Please choose a deduction method',
  placeholder296: 'Please select the correct borrowing date',
  placeholder297: 'Please fill in the correct loan amount',
  placeholder298: 'Please choose the correct payment unit',
  placeholder299: 'Please fill in the reason for the loan',
  placeholder300: 'Please select five insurance types',
  placeholder301: 'Please select the correct data type',
  placeholder302: 'Please input the exemption number',
  placeholder303: 'Please choose the correct option',
  placeholder304: 'Please input a value less than 100',
  placeholder305: 'Please choose the right area',
  placeholder306: 'Please choose the correct year',
  placeholder307: 'Please input the average monthly salary',
  placeholder308: 'Please choose the correct cycle',
  placeholder309: 'Please input the correct special deduction',
  placeholder310: 'Please input a number from 0-100',
  placeholder311: 'Please select the payment area',
  placeholder312: 'Please select the payment method',
  placeholder313: 'Please select a task',
  placeholder316: 'Please input an overall rating',
  placeholder319: 'Please input the reason for the business trip',
  placeholder320: 'Please choose transportation',
  placeholder326: 'Please input the template name',
  placeholder329: 'Please input a number入',
  placeholder335: 'Please select a contract template',
  placeholder338: 'Please choose payroll group!',
  placeholder339: 'Please select payment agreement',
  placeholder340: 'Please fill in the correct time format (YYYY-MM-DD)',
  placeholder341: 'The start date cannot be later than the subordinate start date',
  placeholder342: 'The end date cannot be earlier than the end date of the subordinate',
  placeholder343: 'Please input the correct pension insurance',
  placeholder344: 'Please input the correct medical insurance',
  placeholder345: 'Please input the correct maternity insurance',
  placeholder346: 'Please input the correct unemployment insurance',
  placeholder347: 'Please input the correct scale',
  placeholder351: 'Please input the name',
  placeholder366: 'Please input a positive integer of 18 digits or less',
  placeholder378: 'Please input a keyword',
  placeholder380: 'Please input the application content',
  placeholder396: 'Please select an applicant',
  placeholder397: 'Please input the english name',
  placeholder398: 'Please select truncation date',
  placeholder399: 'Please input the correct number',
  placeholder401: 'The truncation date cannot be earlier than the start date',
  placeholder402: 'The truncation date cannot be later than the end date',
  placeholder403: 'Please input the correct supplementary pension',
  placeholder404: 'Please input the correct complementary medicine',
  placeholder405: 'Please input the correct replenishment ratio',
  placeholder406:
    'The position start time must be greater than or equal to the superior start time',
  placeholder407: 'The position end time should be less than or equal to the superior end time',
  placeholder409: 'Please input the Theme',
  placeholder410: 'Please input the shift name',
  placeholder411: 'Please input the shift english name',
  placeholder412: 'Please input the allowance',
  placeholder413: 'Please input the early leave tolerance',
  placeholder414: 'Please input the tardiness tolerance time',
  placeholder415: 'Please input the working hours',
  placeholder416: 'Please select the rest',
  placeholder417: 'Please select the day level',
  placeholder418: 'Please select the shift type',
  placeholder419: 'Please input the work plan',
  placeholder420: 'Please input the work plan english',
  placeholder421: 'Please Select the Scheduling',
  placeholder422: 'Please select the shift',
  placeholder423: 'Please input the holiday name',
  placeholder424: 'Please input the evaluation type',
  placeholder425: 'Please select the attendance type',
  placeholder426: 'Please Input the place',
  placeholder427: 'Please select the Need to punch in',
  placeholder428: 'Please Input the photo',
  placeholder429: 'Please input the scope',
  placeholder430: 'Please Input the Attendance type',
  placeholder431: 'Please input the applicant (Chinese)',
  placeholder432: 'Please input the applicant (English)',
  placeholder433: 'Please input the number of card boxes to apply for',
  placeholder434: 'Please input a position',
  placeholder435: 'Please input an email',
  placeholder436: 'Please input the reason',
  placeholder437: 'Please input the number of stamps',
  placeholder438: 'Please input applicant',
  placeholder439: 'Please input the item number',
  placeholder440: 'Please input the passenger',
  placeholder441: 'Please select the flight department',
  placeholder442: 'Please input your flight ID number',
  placeholder443: 'Please input your contact information',
  placeholder444: 'Please select a travel date',
  placeholder445: 'Please input the origin',
  placeholder446: 'Please input a destination',
  placeholder447: "Please input the person's name",
  placeholder448: 'Please select the manager department',
  placeholder449: 'Please input the visa place',
  placeholder450: 'Please input the visa type',
  placeholder451: 'Please select a travel time',
  placeholder452: 'Please input the application reason',
  placeholder453: 'Please select the date of stay',
  placeholder454: 'Please input the reason for accommodation',
  placeholder455: 'Please input the accommodation standard',
  placeholder456: 'Please input the number of people',
  placeholder457: 'Please input the recipient',
  placeholder458: 'Please input the recipient company',
  placeholder459: 'Please input the address of the recipient company',
  placeholder460: 'Please input the item number',
  placeholder461: 'Please input the tracking number',
  placeholder462: 'Please input the Shift type',
  placeholder463: 'Please input the Shift type english',
  placeholder464: 'Please input the break_name',
  placeholder465: 'Please input the break_name_en',
  placeholder466: 'Please input the break_time',
  placeholder467: 'Please input the pay_time',
  placeholder468: 'Please input the holiday english name',
  placeholder469: 'Please input the precautions for visiting',
  placeholder470: 'Please input the repair report',
  placeholder471: 'Please input a place',
  placeholder472: 'Please input the shift type',
  placeholder473: 'Please input the shift type in english',
  placeholder474: 'Please input a rest name',
  placeholder475: 'Please input rest english',
  placeholder476: 'Please input the rest time',
  placeholder477: 'Please input pay time',
  placeholder478: 'Please input the holiday english name',
  placeholder479: 'Please select the public holiday',
  placeholder480: 'Please input the Evaluate Type English',
  placeholder481: 'Please input the Attendance type English',
  placeholder482: 'Please input kilometers',
  placeholder483: 'Please select the correct transferee',
  placeholder484: 'Please input the attendance type english',
  placeholder485: 'Please select the Attendance evaluation sheet name ',
  placeholder486: 'Please input the Hour upper',
  placeholder487: 'Please input the Hourly wage',
  placeholder488: 'Please input the Multiple',
  placeholder489: 'Please select the Period',
  placeholder490: 'Please select the deduct_quota',
  placeholder491: 'Please input the minimum unit and no negative number',
  placeholder492: 'Please select the ot_com_med',
  placeholder493: 'Please select the quota',
  placeholder494: 'Please input the round',
  placeholder495: 'Please input the attendance type name',
  placeholder496: 'Please select the Need to take photos',
  placeholder497: 'Please input the leave type',
  placeholder498: 'Please input the Quota name',
  placeholder499: 'Please input the commed name',
  placeholder500: 'Please input the leave type english',
  placeholder501: 'Please input the Quota English Name',
  placeholder502: 'Please input the commed  english name',
  placeholder503: 'Please input the day class name',
  placeholder504: 'Please input the day class english name',
  placeholder505: 'Please input the area',
  placeholder506: 'Please input the housing_base_lower',
  placeholder507: 'Please input the housing_base_upper',
  placeholder508: 'Please input the housing_fund_company',
  placeholder509: 'Please input the housing_fund_emp',
  placeholder510: 'Please input the injure_company',
  placeholder511: 'Please input the injure_emp',
  placeholder512: 'Please input the maternity_company',
  placeholder513: 'Please input the maternity_emp',
  placeholder514: 'Please input the medical_company',
  placeholder515: 'Please input the medical_emp',
  placeholder516: 'Please input the pension_company',
  placeholder517: 'Please input the pension_emp',
  placeholder518: 'Please input the social_base_lower',
  placeholder519: 'Please input the social_base_upper',
  placeholder520: 'Please input the supply_housing_fund_company',
  placeholder521: 'Please input the supply_housing_fund_emp',
  placeholder522: 'Please input the supply_medical_company',
  placeholder523: 'Please input the supply_medical_emp',
  placeholder524: 'Please input the supply_pension_company',
  placeholder525: 'Please input the supply_pension_emp',
  placeholder526: 'Please input the unemployment_company',
  placeholder527: 'Please input the unemployment_emp',
  placeholder528: 'Please input the serial',
  placeholder529: 'Please input the top',
  placeholder530: 'Please input the bottom',
  placeholder531: 'Please input the rate',
  placeholder532: 'Please input the deduct',
  placeholder534: 'Please select the deduct_method',
  placeholder535: 'Please input the name',
  placeholder536: 'Please input the short_name',
  placeholder537: 'Please select the plus',
  placeholder538: 'Please input the type',
  placeholder539: 'Please select the cur_period',
  placeholder540: 'Please select the first_period',
  placeholder541: 'Please select the retro_period',
  placeholder542: 'Please select the time_period',
  placeholder543: 'Please input the status',
  placeholder544: 'Please select the company',
  placeholder545: 'Please input the note',
  placeholder546: 'Please select the encrypt',
  placeholder547: 'Please input the title',
  placeholder548: 'Please input your education',
  placeholder549: 'Please input the serial',
  placeholder550: 'Please input the level',
  placeholder551: 'Please input basic salary',
  placeholder552: 'Please input the skill',
  placeholder553: 'Please input probationary salary',
  placeholder554: 'Please input Saturday overtime allowance',
  placeholder555: 'Please input performance bonus',
  placeholder556: 'Please input management allowance',
  placeholder557: 'Please input skill allowance',
  placeholder558: 'Please input the accommodation allowance',
  placeholder559: 'Please input phone allowance',
  placeholder560: 'Please input the attendance bonus',
  placeholder561: "Please input the employee's monthly salary",
  placeholder562: 'Please select a date of birth',
  placeholder563: 'Please input the note english',
  placeholder564: 'Cannot be earlier than start time',
  placeholder565: 'Not later than the end time',
  placeholder566: 'Please select the correct account status',
  placeholder567: 'Please select the correct punch-in address',
  placeholder568: 'The punch-in address cannot be empty',
  placeholder570: 'Please input the name',
  placeholder571: 'Please input the field_name',
  placeholder572: 'Please input the field_en_name',
  placeholder573: 'Please input the field_id',
  placeholder574: 'Please input the contract quantity',
  placeholder575: 'Please input the icon',
  placeholder576: 'Please input the type_name',
  placeholder577: 'Please input the type_name_en',
  placeholder578: 'Please input the contract_type',
  placeholder579: 'Please input the filter_table',
  placeholder580: 'Please input the template',
  placeholder581: 'Please select the type',
  placeholder582: 'Please select the lng',
  placeholder583: 'Please select the lat',
  placeholder584: 'Please select the scope',
  placeholder585: 'Please input the configure',
  placeholder586: 'Please select the menu',
  placeholder587: 'Please select the description name',
  placeholder588: 'Please select the icon',
  placeholder589: 'Please select the process key',
  placeholder590: 'Please select the sync proc',
  placeholder591: 'Please select the title',
  placeholder592: 'Please select the vendor',
  placeholder593: 'Please select the time',
  placeholder594: 'Please select the description name en',
  placeholder595: 'Please input the selection name',
  placeholder596: 'Please input english characters',
  placeholder597: 'Please input a positive integer',
  placeholder598: 'Please input a positive integer and the maximum number of digits is 8',
  placeholder599: 'Please input pay rate',
  placeholder600: 'Please input up to 6 integer digits and 2 decimal digits',
  placeholder601: 'Please input up to 5 integer digits and 2 decimal digits',
  placeholder602: 'Please input up to 2 integer digits and 1 decimal digits',
  placeholder603: 'Please input up to 5 integer digits and 3 decimal digits',
  placeholder604: 'The start time cannot be later than the end time',
  placeholder605: 'The end time cannot be earlier than the start time',
  placeholder606: 'Please input a natural number',
  placeholder607: 'Please input up to 17 integer digits and 3 decimal digits',
  placeholder608: 'Please input the compensation ratio',
  placeholder609: 'Please input the n+',
  placeholder610: 'Please select the module',
  placeholder611: 'The end time cannot be earlier than the start time',
  placeholder612: 'The new job number must be greater than or equal to the previous job number',
  placeholder613: 'Please select the shift type',
  placeholder614: 'Please select the development type',
  placeholder615: 'Please select the development type',
  placeholder616: 'Please select the phone number',
  placeholder617: 'Please select the level',
  placeholder618: 'Please select the action name',
  placeholder619: 'head length + tail length + length should be less than or equal to 20',
  placeholder620: 'The new mailbox input box cannot be empty!',
  placeholder621: 'The verification code input box cannot be empty!',
  placeholder622: 'Please input the process',
  placeholder623: 'Please input the job desc',
  placeholder624: 'Please select the job group',
  placeholder625: 'Please input the job handler',
  placeholder626: 'Please select the scope of execution',
  placeholder627: 'Please select the period',
  placeholder628: 'Please select the executor param',
  Placeholder629: 'Please select the Line',
  Placeholder630: 'Please select the Site',
  placeholder631: 'User',
  placeholder632: 'Please input Number of copies',
  placeholder633: 'Please input Approved by',
  placeholder634: 'Please input Supervisor',
  placeholder635: 'Please input Stamp content',
  placeholder636: 'Please input Applicant Position',
  placeholder637: 'Please input Equipment number',
  placeholder638: 'Please input Model',
  placeholder639: 'Please input Device Location',
  placeholder640: 'Please input Repair Reason',
  placeholder641: 'Please input Opinions Of The Requesting Department',
  placeholder642: 'Please input Maintenance Unit',
  placeholder643: 'Please input Repair Or Replace Unit',
  placeholder644: 'Please input Applicant Title',
  placeholder645: 'Please input Reason For Payment',
  placeholder646: 'Please input Payment Amount (CNY)',
  placeholder647: 'Please input Payment Method',
  placeholder648: 'Please input Payee',
  placeholder649: 'Please input Bank Account',
  placeholder650: 'Please select Training Format',
  placeholder651: 'Please input Training Institution',
  placeholder652: 'Please input Training Machine Class',
  placeholder653: 'Please input Reason For Application',
  placeholder654: 'Please input Stamp Name',
  placeholder655: 'Please input Custody Department',
  placeholder656: 'Please input Engraved By',
  placeholder657: 'Please input Seal Specialist',
  placeholder658: 'Please input Seal Purpose',
  placeholder659: 'Please input Stamp Retention Sample',
  placeholder660: 'Please input model/specification',
  placeholder661: 'Please select a delivery date',
  placeholder662: 'Please input unit price',
  placeholder663: 'Please input unit',
  placeholder664: 'Please select date',
  placeholder665: 'Please input number of attachments',
  placeholder666: 'Please select an annual leave code',
  placeholder667: 'Please select position of agent',
  placeholder668: 'Please select educational',
  placeholder669: 'Please input repair fee',
  placeholder670: 'Please input personnel administrative opinion',
  placeholder671: 'Please input prepaid travel expenses',
  placeholder672: 'Please select the vacation that needs to be cancelled',
  placeholder673: 'Please input reason for cancellation',
  placeholder674: 'Edit Service Terms Content',
  placeholder675: 'Please select the superior organization',
  placeholder676: 'Please select the Project',
  placeholder677: 'Please select the Task',
  placeholder678: 'Please input Working Hours',
  placeholder679: 'Please select the act end',
  placeholder680: 'Please select the owen',
  placeholder681: 'Please select the reporter',
  placeholder682: 'Please select the reporter date',
  placeholder683: 'Please select the working hours',
  placeholder685: 'Please select the plan start',
  placeholder686: 'Please select the plan end',
  placeholder687: 'Please select the act start',
  placeholder688: 'Explanation of reasons',
  placeholder689: 'Automatically calculate results',
  placeholder692: 'The loan date cannot be later than the repayment date',
  placeholder693: 'Please input the correct working hours',
  placeholder694: 'Please fill in the job description',
  placeholder695: 'Please input your graduation school',
  placeholder696: 'Please input the employment salary',
  placeholder697: 'Please input the probation period',
  placeholder698: 'Please upload the attached probationary assessment form',
  placeholder699: 'Please input the reason for resignation',
  placeholder700: 'Please select resignation type',
  placeholder701: 'Resignation time cannot be earlier than onboarding time',
  placeholder702: 'The probation period cannot be earlier than the start date',
  placeholder703: 'Please input the correct age',
  placeholder704: 'Please input the number',
  placeholder705: 'Please input approval comments',
  placeholder706: 'Auto filled',
  placeholder707: 'Please input the correct Price with VAT',
  placeholder708: 'Please input the correct VAT Rate',
  placeholder709: 'Please input the Visiting Reason',
  placeholder710: 'Please input the Respondent',
  placeholder711: 'Please input the Guider',
  placeholder712: 'Please select the Type of Vehicles',
  placeholder713: 'Please input the NO. of Vehicles',
  placeholder714: 'Please input the correct No. of Passengers',
  placeholder715: 'Please input the correct Single Pass Distance',
  placeholder716: 'Please input the Visiting Time',
  placeholder717: 'Please select the Vehicles',
  placeholder718: 'Visitor invitation link expired',
  placeholder719: 'Visitor invitation link is invalid',
  placeholder720: 'Please input the Performance Allowance Base',
  placeholder721: 'Please input the Finial Score',
  placeholder722: 'Please input the Final Ferformance Allowance',
  placeholder723: 'Please input ',
  placeholder724: 'Please input vacation days',
  placeholder725: 'Please input salary range',
  placeholder726: 'Please select resignation approval',
  placeholder727: 'Please select training type',
  placeholder728: 'Please input training name',
  placeholder729: 'Please input training purpose',
  placeholder730: 'Please input event description',
  placeholder731: 'Please input root cause analysis',
  placeholder732: 'Please input corrective measures',
  placeholder733: 'Please select completion time',
  placeholder734: 'Please select event type',
  placeholder735: 'Please enter hazard description',
  placeholder736: 'Please upload photos before rectification',
  placeholder737: 'Please upload photos after rectification',
  placeholder738: 'Please select planned completion time',
  placeholder739: 'Please select rectification completion time',
  placeholder740: 'Please select responsible person',
  placeholder741: 'Please enter English name',
  placeholder742: 'Please enter job English name',
  placeholder743: 'Please enter repair location',
  placeholder744: 'Please enter correct email format',
  placeholder745: 'Please select the employee type',
  placeholder746: 'Please select the change type',
  placeholder747: 'Please select the effective date',
  placeholder748: 'Please enter office phone',
  placeholder749: 'Please enter mobile phone',
  contentTitle01: 'I. Confirmation and acceptance of the terms of service',
  contentTitle02: 'II. Service Protection Terms',
  contentTitle03: 'Three, service content',
  contentTitle04: 'Four, user usage rules',
  contentTitle05: 'V. Modifications and Publicity of Terms of Service',
  contentTitle06: 'six, service revision',
  contentTitle07: "VII. User's rights and obligations",
  contentTitle08: 'eight, breach of contract terms',
  contentTitle09: 'Nine, end service',
  contentTitle10: 'Ten, intellectual property',
  contentTitle11: 'Eleven, dispute resolution',
  contentTitle12: 'Twelve, other',
  content01:
    '2175 Cloud is a professional human resources SAAS cloud platform developed by Suzhou Luca Information Technology Co., Ltd. Before logging in and using this service, users should carefully read the "Luca Cloud Terms of Service" (hereinafter referred to as "this agreement"). Please read carefully and fully understand the contents of each clause, especially the clauses such as exemption or limitation of liability. When the user clicks the "Accept Terms of Service" button during the first login to the cloud platform, it means that the user and Suzhou Luca Information Technology Co., Ltd. have reached an agreement to voluntarily accept all the contents of the terms of service. Any revisions and new rules will automatically become part of the terms of service once they are published, and the user\'s behavior of logging in or continuing to use the service will be deemed to be an expression of acceptance of the above-mentioned revisions to the rules and willingness to continue to perform the contract. Suzhou Lucca Information Technology Co., Ltd. has the right to supervise, remind, inspect, correct and punish all activities on its Lucca Cloud application.',
  content02:
    'In particular, millet reminds users to read carefully and fully understand the provisions of this agreement, including exemptions or limitations of millet liability and restrictions on the rights of users. Please read this Agreement carefully and choose to accept or reject it (minors should be accompanied by legal guardians). Unless you accept all the terms and conditions of this agreement, you are not authorized to register, log in or use the services involved in this agreement. Your registration, login, use, etc. will be deemed to be an acceptance of this Agreement, and agree to be bound by the provisions of this Agreement.',
  content03:
    'Your acceptance of this Agreement means that you are voluntarily bound by all the terms and conditions of this Agreement, including acceptance of any modification made at any time by Millet Company to any of the terms and conditions of service. This agreement can be updated by millet at any time. Once the updated agreement terms are published, they will replace the original agreement terms. Without further notice, users can consult the latest version of the agreement terms on this website. After millet amends the relevant provisions of this agreement, if the user does not accept the amended terms, please immediately stop using the millet services, users continue to use millet services will be deemed to have accepted the amended agreement.',
  content04: 'Warning',
  content05:
    "Specially remind users that the network services provided by Luca Cloud must comply with relevant national policies and laws, including criminal law, national security law, confidentiality law and other computer information system security protection regulations. Users should consciously safeguard national interests. To protect national security, the user is solely responsible for all responsibility for the illegal use of the network services provided by Luca Cloud. 1. When applying for the network service provided by Lukayun, users must provide true and accurate personal data or institutional information to Lukayun. If there is any change in personal data or institutional information, it must be updated in time. 2. After the user logs in successfully, Lukayun will give each user one or more user accounts and corresponding passwords. The user account and password are kept by the user; the user can change their password at any time. The user shall be legally responsible for all activities and events carried out by his user account. If the user finds any illegal use of his user account or security breach, he or she will immediately notify Lukayun. 3. Users may not use the Luca Cloud Service to send or disseminate information that violates the national legal system, sensitive information, and information that is not appropriate to be sent or transmitted, including but not limited to the following information: • (1) against the basic principles established by the Constitution; (2) Endangering national security, revealing state secrets, subverting state power, and undermining national unity; • (3) damaging national honours and interests; • (4) inciting national hatred, ethnic discrimination, and undermining national unity; Destroy the state's religious policies and promote cults and feudal superstitions; • (6) spread rumors, disrupt social order, and undermine social stability; • (7) spread obscenity, pornography, gambling, violence, murder, terror, or abetment; • (8) Insulting or slandering others, infringing on the legitimate rights and interests of others; • (9) Containing other content prohibited by law or administrative regulations. 4. Users must follow the following principles in the process of using Luca Cloud network services: • (1) comply with relevant Chinese laws and regulations; • (2) not use the network service system for any illegal purposes; • (3) comply with All network protocols, regulations, and procedures related to network services; • (4) Do not use Lucca Cloud for any behavior that may adversely affect the normal operation of the Internet; • (5) Do not use Road Card Cloud to transmit any harassing , injure others, insulting, intimidating, vulgar, obscene, or any other illegal information; • (6) Do not use Lukayun for any behavior that is not conducive to Lukayun. If the user's behavior does not comply with the above mentioned terms of service, Lukayun will make an independent judgment to immediately cancel the user service account. 5. Using the Lukayun website service, the user should strengthen the protection awareness of personal or institutional data, and pay attention to the password protection of the user account. 6. It is illegal to steal another user's account or use the network communication to harass others. Users must not use any illegal means such as testing, fraud, etc. to steal accounts of other users and harass others. 7. Suzhou Luka Information Technology Co., Ltd. reserves the right to independently determine whether the user's behavior complies with the requirements and spirit of the Lukayun Service Terms. If the user violates the terms of the service, Suzhou Luka Information Technology Co., Ltd. has the right to interrupt or Delete their account number. If the user disagrees with the interruption or deletion of the road card cloud, it shall submit it to Suzhou Luka Information Technology Co., Ltd. within five working days after the interruption or deletion is made. 8. Lukayun is not responsible for the self-deletion or storage failure of the information published by the user. 9. All notices sent to users can be sent by email or regular mail. Lukayun will send a message to the user via the mail service to inform the modification of the terms of service, service changes, or other important matters. ",
  content06:
    'Suzhou Luka Information Technology Co., Ltd. will modify the terms of service when necessary. Once the content of this agreement changes, Suzhou Luka Information Technology Co., Ltd. will directly announce the revised agreement content on the website. For Suzhou Luka Information Technology Co., Ltd., the user has been notified to modify the content. Suzhou Luka Information Technology Co., Ltd. can also prompt users to modify the content in other appropriate ways. If you disagree with Suzhou Luka Information Technology Co., Ltd. to modify the relevant terms of this agreement, the user has the right to stop using the network service. If the user continues to use the network service, the user is deemed to accept Suzhou Luka Information Technology Co., Ltd. Modifications made. If any of the terms of service conflicts with the law, those terms will be re-analyzed as close as possible, while other terms continue to have legal effect and influence on the user. ',
  content07:
    'Lukayun specifically reminds users that Lukayun has the right to modify or interrupt the service in order to protect the system upgrade. Lukayun informs the user through the website announcement or email to modify or interrupt the service period. During the interruption of the service, the user Users will not be able to operate online, please pay attention to check the announcement or check the mail information. ',
  content08:
    '•(1) The user should provide Lukayun with the personnel information he has used, including but not limited to business licenses, existing staffing information and other information. • (2) Users should actively cooperate with Luca Cloud to provide corresponding information. Users can choose the appropriate solution according to their needs and characteristics. For example, you can choose the online cloud service provided by Luca Cloud. • (3) During the cooperation period, the user guarantees that the information provided to Lukayun (including nested information content) is true and legal, and does not infringe the legitimate rights and interests of the third party. Users should have corresponding intellectual property rights or legal use rights for the content, and these rights certification documents should be submitted to Luca Cloud at the same time. • (4) The user has a confidentiality obligation to Lukayun and shall not disclose to any other party in any way any information disclosed by Lukayun that is known during the performance of this Agreement. • (5) The User shall use the name and logo of the Road Card Cloud within the scope of this Agreement. If you need to use the name and logo of the road card cloud outside the road card cloud, you should obtain the written authorization of Suzhou Road Card Information Technology Co., Ltd. The user shall ensure that the name and logo of the road card cloud are properly used and shall not be modified, tailored, altered or improperly quoted. • (6) With the written permission of Suzhou Luca Information Technology Co., Ltd., users can add promotional materials or advertising plans to their published information to display their products in the free services provided by Luca Cloud. Users should ensure the authenticity and legitimacy of their published content. Lukayun does not make substantive examination of the above contents. If a dispute arises between the user and a third party, it shall bear full responsibility for it. If the loss is caused to Suzhou Luka Information Technology Co., Ltd., the user shall be compensated. ',
  content09:
    "•(1) The conclusion, execution and interpretation of this Agreement and resolution of disputes shall be governed by the laws of the People's Republic of China. • (2) This Agreement is effective as long as you log in using Lukayun. (3) Suzhou Luka Information Technology Co., Ltd. reserves the right to interpret this Agreement to the extent permitted by law. ",
  content10:
    "If the user objects to any of the terms of service or disagrees with subsequent changes to the terms, or is dissatisfied with the service of Suzhou Luca Information Technology Co., Ltd., the user has the following rights: • (1) The service of Lukayun is no longer used. • (2) End the user's eligibility to use the Luca cloud service. • (3) Written notice Suzhou Luka Information Technology Co., Ltd. to stop the user's services. After the end of the user service, the user's right to use the Luka cloud service is immediately terminated, and Suzhou Luka Information Technology Co., Ltd. no longer assumes any obligations to the user. ",
  content11:
    "User warranties and representations have full legal copyright or full legal authorization for the work they provide to be used for their activities on Lucca Cloud, ensuring that Luca Cloud does not violate national laws. The regulations do not infringe on the legal rights or obligations of third parties. Users are solely responsible for all consequences of the works, the content and the imperfections and illegality of the works provided. Suzhou Luka Information Technology Co., Ltd. reserves the right to monitor all the contents of Lukayun website in real time, and has the right to delete any works in violation of this agreement according to its independent judgment. Lukayun has any consequences for deleting user works. Or assume no responsibility for any loss to the user. Loss (direct, indirect, accidental, punitive) by Lukayun Company or its affiliates for any kind of compensation, compensation or fine of any nature to third parties due to illegal activities of the user's work or infringement of the lawful rights and interests of third parties And the subsequent losses), the user is responsible for the above-mentioned losses of Suzhou Luka Information Technology Co., Ltd. and its affiliates or Lukayun. ",
  content12:
    'If there is any dispute between the parties regarding the content of this agreement or its implementation, the parties should try to resolve it through friendly negotiation. When the negotiation fails, either party may file a lawsuit in the court where the Suzhou Luka Information Technology Co., Ltd. is located. ',
  content13:
    "•(1) Lukayun will treat the characteristics of the service content provided by the user, and require the user to abide by the specific terms and conditions when registering the related services provided by Luca Cloud; if the specific terms and conditions are related to the above services In the event of any inconsistency in the Terms, the specific terms and conditions shall prevail. • (2) A clause of the Terms of Service is deemed invalid or non-executive for any reason and does not affect the remaining provisions and shall remain valid and binding. • (3) Any problems arising from the implementation of these Terms of Service will be resolved through friendly negotiation between Lukayun and the users. • (4) The right to interpret the above terms is the property of Suzhou Luka Information Technology Co., Ltd. Lukayun User Data Privacy Commitment Lukayun (https://cloud.luttica.com/) is developed by Suzhou Luka Information Technology Co., Ltd., hereinafter referred to as Suzhou Luka Information Technology Co., Ltd. or Luka Information Technology. Online human resource management tool. In order to better meet the needs of users, serve the users, and to protect the security of user data, Suzhou Luka Information Technology Co., Ltd. has made the following confidentiality commitments. 1. Commitment to confidentiality The road card registration used by the customer involves all the employee's file data and customer information input into the system. Including: employee files, employee data, etc. are confidential information of customers. 2. Confidentiality Responsibilities Without permission from the user, Suzhou Luka Information Technology Co., Ltd. shall fulfill the following confidentiality obligations: • a. Suzhou Luka Information Technology Co., Ltd. must take effective safety measures and operating procedures to prevent user information from being leaked. • b. Suzhou Luka Information Technology Co., Ltd. cannot disclose user information to third parties, and only allows information to be disclosed to the user's management level personnel and contractors. • c. Suzhou Luka Information Technology Co., Ltd. takes effective measures to permanently and strictly keep all information from users. 3. Restricted Use Restrictions • a. Without the consent of the user, Suzhou Luka Information Technology Co., Ltd. shall not disclose any rights related to commercial use rights, patent rights, reproduction rights, trademarks, technical secrets, trade secrets or other proprietary rights. • b. Without the consent of the user, Suzhou Luca Information Technology Co., Ltd. shall not use the cooperation matters and confidential content for commercial promotion or business partners disclosed to users for commercial purposes or other units that threaten the interests of users or personal. 4. Other confidentiality commitments shall come into effect when the customer signs up to use Lukayun of Suzhou Luka Information Technology Co., Ltd., and the premise shall be that it does not violate the laws and regulations of the People's Republic of China, does not endanger social security, and does not harm the national interest. Under the following circumstances, Suzhou Luka Information Technology Co., Ltd. does not assume the responsibility of confidentiality. • 1. The information has been known or made public by others before use or publication, or the information caused by the wrong behavior of non-Suzhou Luca Information Technology Co., Ltd. has been made public. • 2. The user has not released the information published in the case of the Suzhou Luka Information Technology Co., Ltd.. • 3. In principle, after the service is completed, Suzhou Luka Information Technology Co., Ltd. will also permanently and strictly keep all information from users.",
  content14:
    'Applicable to new employees to enter the application, the approval is automatically entered into the pending status, and the approval is automatically entered into the pending status',
  content15:
    'The truncation simultaneously truncates the end date of the organization, position, and assigned employees to its subordinates, please confirm that the truncation continues?',
  content16: 'Are you sure you want to suspend the current application?',
  content17: 'Are you sure you want to cancel the current application?',
  rules01: 'Please fill in the correct username',
  rules02: 'Please fill in the correct password',
  rules03: 'Please completing verification',
  rules04: 'Please fill in the correct customer code',
  rules05: 'Please fill in the correct mailbox.',
  rules06: 'The two password is inconsistent.',
  rules07: 'Please input correct the correct name.',
  rules08: 'Please input correct the correct telephone number.',
  rules09: 'Please input correct the correct content.',
  rules10: 'Please input correct the correct device name.',
  rules11: 'Username',
  rules12: 'Tel',
  rules13: 'Email',
  rules14: 'Please input correct the correct',
  rules15: 'please chose relationship',
  rules16: 'Please input your password',
  rules17: 'Please input email',
  rules18: 'User name cannot be empty',
  rules19: 'Password cannot be empty',
  rules20: 'You have not bound your mobile yet',
  rules21: 'You have not bound your email yet',
  rules22: 'Your mobile number',
  rules23: 'Please input the specified special characters[  ,/,:,@,[,`,{,~ ]',
  rules24: 'Please select the correct date',
  rules26: 'The same contract already exists',
  message01: 'Logout failed, please retry!',
  message02: 'Reset successfully, please login again!',
  message03: 'Login successfully!',
  message04: 'Write off successfully!',
  message05: 'Please input the data input correct incorrectly!',
  message06: 'Submit successfully!',
  message07: 'Edit my application',
  message08: 'Edit completed!',
  message09: 'Modified successfully!',
  message10: 'Binding success!',
  message11: 'Untying successfully!',
  message12: 'Only upload background pictures!',
  message13: 'Upload background image size should not exceed 2MB!',
  message14: 'Add background success!',
  message15: 'Deleted successfully!',
  message16: 'Replication success!',
  message17: 'Save success!',
  message18: 'Please select at least one message!',
  message19: 'Exit edit',
  message20: 'Verify pass',
  message21: 'The new password cannot be the same as the old password! ',
  message22: 'Cancel input is correct',
  message23: 'Overtime for specific time period',
  message24: 'Sorry, system error! Please try refresh or return to home page.',
  message25: 'Reset failure, please login again!',
  message26: 'Undelete! ',
  message27: 'The employee is not registered for the account! ',
  message28: "Sorry, you can't modify yourself data!",
  message35: 'You have to pay manually for this payment method!',
  message36: 'You have to pay manually for this payment method!',
  message37: 'The colleague is wrong and cannot choose himself as the colleague',
  message38:
    'After saving successfully, you can add more records by adding, or click the arrow on the right to go to the next information type!',
  message39: 'Please click save below to save the current data～',
  message40: 'Overlap with existing data, whether to overwrite the original record？',
  message41: 'The transfer was successful',
  message42: 'Link error',
  message43: 'Sorry, no user found!',
  message45: 'Unbinding succeeded! ',
  message46: 'Unbind failed!',
  message44: 'Binding failed!',
  message47:
    'You have not bound your phone number and email address, please bind your phone number and email address first',
  message48: 'System update is in progress. . . . ',
  message49:
    'Note: If the equipment damage is caused by human factors, the repair cost shall be borne by the user or compensated according to the price.',
  message50: 'User does not have a position',
  message51: 'Invalid association',
  message52: 'Attachment upload',
  message53:
    'External training fee exceeding 4000 yuan requires signing a training service agreement',
  message54:
    'Service period: External training over 4000 yuan requires a training service agreement; submit a training summary after completion.',
  optionMenu1: 'Change Password',
  optionMenu2: 'Binding Device',
  optionMenu3: 'Notice Method',
  optionMenu4: 'Proxy Setting',
  optionMenu5: 'Background Setting',
  staffMenu1: 'Employee Information',
  staffMenu2: 'Time Data',
  staffMenu3: 'Payroll Data',
  helpMenu1: '1. Click login failed.',
  helpMenu2: '2. Reset password failed?',
  helpMenu201: 'Submenu',
  helpMenu202: 'Submenu',
  helpMenu203: 'Submenu',
  helpMenu3: 'System function introduction',
  router01: 'Home',
  router02: 'Employee Profile',
  router03: 'Report Line',
  router04: 'Self-Help Center',
  router05: 'Welfare Center',
  router06: 'Report center',
  router07: 'Personnel management',
  router09: 'Organization',
  router08: 'System management',
  router10: 'Personnel Examination and Approval',
  router11: 'Attendance Examination and Approval',
  router12: 'Administrative Examination and Approval',
  router13: 'Other',
  router14: 'Job Application',
  router15: 'Recruitment',
  router16: 'Regular',
  router17: 'Transfer',
  router18: 'Contract Signing',
  router19: 'Bonus Allowance',
  router20: 'Pay Raise',
  router21: 'Transfer',
  router22: 'Contract Signing',
  router23: 'Bonus Allowance',
  router24: 'Financial Examination and Approval',
  router25: 'Data Center',
  router26: 'Borrow',
  router27: 'Post application is out of budget',
  router31: 'Office Equipment Maintenance Application Form',
  router32: 'Purchase requisition',
  router33: 'Reimbursement form',
  router34: 'Registration of official seal usage',
  router35: 'Seal engraving application',
  router36: 'Cancellation of leave',
  homelist01: 'Enterprise Compass',
  homelist02: 'Welcome to Join',
  homelist03: 'New Employee',
  homelist04: 'Reporting Relationship',
  homelist05: 'Organizational Structure',
  homelist06: 'Talent Compass',
  homelist07: 'My Request',
  homelist08: 'To Do',
  homelist09: 'Self-Help Center',
  homelist10: 'Time Quota',
  homelist11: 'My Attendance',
  homelist12: 'Attendance Control',
  homelist13: 'My salary',
  homelist14: 'Large data analysis',
  homelist15: 'Personnel Management',
  homelist16: 'System Management',
  homelist17: 'Birthday Employee',
  homelist18: 'Core Personnel',
  dataCenter01: 'Employee Analysis',
  dataCenter02: 'Organization List',
  dataCenter03: 'Employment Status',
  dataCenter04: 'Position List',
  dataCenter05: 'Position Assignment',
  dataCenter06: 'Overtime Analysis',
  dataCenter07: 'Time evaluation Result',
  dataCenter08: 'Employee Salary',
  dataCenter09: 'Individual income tax',
  dataCenter10: 'Proof of income',
  dataCenter11: 'Resignation Certificate',
  dataCenter12: 'User Log',
  dataCenter13: 'Logging',
  guideTitle1: '1. Logo',
  guideTitle2: '2. Main Menu',
  guideTitle3: '3. Search Box',
  guideTitle4: '4. User Menu',
  guideTitle5: '5. User Information',
  guideTitle6: '6. My News',
  guideTitle7: '7. My Application',
  guideContent1: 'Click Logo to return to the front page.',
  guideContent2: 'Click on the main menu of the system.',
  guideContent3: 'Input name search staff.',
  guideContent4: 'Click to open user menu.',
  guideContent5: 'Click to view employee details.',
  guideContent6: 'Click to view all messages.',
  guideContent7: 'Click the display / hide application menu.',
  guideButton1: 'Next',
  guideButton2: 'Finish',
  pmMenu01: 'Online consultant',
  pmMenu02: 'Self-Management',
  pmMenu03: ' Entry Management',
  pmMenu04: 'Staff Management',
  pmMenu05: 'Organizational Management',
  pmMenu06: 'Time Management',
  pmMenu07: 'Salary Management',
  pmMenu08: 'OKR Workshop',
  pmMenu09: 'Budget Management',
  pmMenu10: 'Salary Adjustment',
  tableTitle01: 'Base Information',
  tableTitle02: 'Organization Relationship',
  tableTitle03: 'Address',
  tableTitle04: 'Pay Information',
  tableTitle05: 'Family',
  tableTitle06: 'Contract',
  tableTitle07: 'Education',
  tableTitle08: 'Former employer',
  tableTitle09: 'Skill',
  tableTitle10: 'Prize Info',
  tableTitle11: 'Date',
  tableTitle12: 'Projects',
  tableTitle13: 'Loan',
  tableTitle14: 'Partner',
  tableTitle15: 'Vehicles',
  tableTitle16: 'Languages',
  tableTitle17: 'Data State',
  tableTitle18: 'Work Plan',
  tableTitle19: 'Substitution',
  tableTitle20: 'Fill Clock In',
  tableTitle21: 'Leave',
  tableTitle22: 'Overtime',
  tableTitle23: 'Time Quota',
  tableTitle24: 'Time Salary Item',
  tableTitle25: 'Basic Wage',
  tableTitle26: 'Periodic Salary Item',
  tableTitle27: 'Temp Salary Item',
  tableTitle28: 'Shuttle',
  tableTitle29: 'Working Meal',
  tableTitle30: 'Car',
  tableTitle31: 'Item Use',
  tableTitle32: 'Print',
  tableTitle33: 'Reimbursement',
  tableTitle34: 'Payment',
  tableTitle35: 'Purchasing',
  tableTitle36: 'Contract Approval',
  tableTitle37: 'Project',
  tableTitle38: 'Attendance',
  tableTitle39: 'Attendance evaluation sheet',
  tableTitle40: 'Out',
  tableTitle41: 'Business Trip',
  tableTitle43: 'Administrative Purchasing',
  PA01: 'Basic Information',
  PA02: 'Organization Management',
  PA03: 'Address',
  PA04: 'Payment Information',
  PA05: 'Family Member',
  PA06: 'Contract',
  PA07: 'Education',
  PA08: 'Former Employer',
  PA09: 'Professional title and skills ',
  PA10: 'Reward and punishment',
  PA11: 'Date',
  PA12: 'Development Project',
  PA13: 'Borrowing',
  PA14: 'Partner',
  PA15: 'Transportation',
  PA16: 'Language skills',
  TM01: 'Working Plan',
  PY02: 'Base Salary',
  PY03: 'Cycle Salary',
  PY04: 'Temporary Salary',
  list01: 'Basic Information',
  list02: 'Organization Assignment',
  list03: 'Address',
  list04: 'Payment Information',
  list05: 'Family',
  list06: 'Contract',
  list07: 'Education',
  list08: 'Former Employer',
  list09: 'Title and Skill',
  list10: 'Reward and Punishment',
  list11: 'Date',
  list12: 'Development Program',
  list13: 'Borrow and Loan',
  list14: 'Partner',
  list15: 'Vehicles',
  list16: 'Language Ability',
  list17: 'Data Status',
  list18: 'Work Schedule',
  list19: 'Basic Pay',
  list20: 'Recurring Pay',
  list21: 'Additional Pay',
  list22: 'Drag the slider to verify',
  list23: 'Time Quota',
  list24: 'Time Salary',
  list25: 'Upload Attachment',
  list26: 'Employee',
  list27: 'Current Date',
  list28: 'Punch Position',
  list29: 'On-the-job punching',
  list30: 'Leaving the punch card',
  list31: 'On-the-job punching',
  list32: 'Departure punch card',
  list33: 'Punch Time',
  list34: 'Card Type',
  list35: 'Not Punched',
  list36: 'Leadership Position',
  list37: 'Add',
  list38: 'Boarding time',
  list39: 'Channel',
  list40: 'Details',
  list41: 'Action',
  list42: 'User Name',
  list43: 'Date range',
  list44: 'Confidence index',
  list45: 'fraction',
  list46: 'content',
  list47: 'KR details',
  list48: 'helper',
  list49: 'Task list',
  list50: 'OKR details',
  list51: 'China Merchants Bank',
  list52: 'Alipay',
  list53: 'Wechat payment',
  list54: 'Offline payment',
  loading: 'Loading ...',
  model01: 'Name',
  model02: 'Company',
  model03: 'Cost Center',
  model04: 'Location',
  model05: 'Start Date',
  model06: 'End Date',
  model07: 'Org Category',
  model08: 'Superior Org',
  model09: 'Organization',
  model10: 'Position',
  model11: 'Position Rank',
  model12: 'Key Job',
  model13: 'Dotted Report',
  model14: 'Supervisor',
  model15: 'Yes',
  model16: 'No',
  model17: 'Type',
  model18: 'Supervisor',
  model19: 'Distribution',
  model20: 'Search',
  model21: 'Staff',
  model22: 'Superior Org',
  model23: 'Data',
  model24: 'Truncation',
  model25: 'Move',
  entry01: 'Entry Date',
  entry02: 'Attachment',
  entry03: 'State',
  entry04: 'Handler',
  entry05: 'Submitter',
  entry06: 'Satisfaction Survey',
  entry07: 'Entry',
  entry08: 'All',
  entry09: 'Handle Date',
  entry10: 'Onboarding',
  open: 'Expand',
  reOpen: 'Shrink',
  index01: 'Year',
  index02: 'Month',
  index03: 'Shift',
  index04: 'Day',
  index05: 'One',
  index06: 'Two',
  index07: 'Three',
  index08: 'Four',
  index09: 'Five',
  index10: 'Six',
  index11: "New Year's Day",
  index12: 'Spring Festival',
  index13: 'Ching Ming Festival',
  index14: 'Labor Day',
  index15: 'Dragon Boat Festival',
  index16: 'Mid-Autumn Festival',
  index17: 'National Day',
  filter01: 'Trial period',
  filter02: 'On the Job',
  filter03: 'Waiting for posts',
  diver01: 'The',
  diver02: 'Strip Data',
  new01: 'There is no attachment！',
  new02: 'Interview center',
  new03: 'Address',
  new04: 'Please input gender',
  new05: 'Do you want to exit after submitting!',
  new06: 'Required information not entered ',
  new07: 'Member Name ',
  new08: 'Please input member name ',
  new09: 'Abandoning Submit',
  new10: 'No attachments',
  new11: "Demand can't be rejected！",
  new12: "Demand can't be rejected！",
  new13: 'Approval Details',
  new14: 'Click to view details',
  new15: 'Payment Method',
  new16: 'Please choose the correct payment method',
  new17: 'Payment Place',
  new18: 'Please choose the correct payment place',
  new19: 'Base number',
  new20: 'Please input the base',
  new21: 'Proportion',
  new22: 'Please input the proportion (%)',
  new23: 'Social Security Account',
  new24: 'Please input social security account number',
  new25: 'Provident Fund Account Number',
  new26: 'Please input the provident fund account number',
  new27: 'Total Income',
  new28: 'National Policy',
  new29: 'Normal payment',
  new30: 'Employee Payment',
  new31: 'Company payment',
  new32: 'Not paid',
  new33: 'Printing and Dyeing Project',
  new35: 'Associated Project',
  new36: 'Customer',
  new37: 'Pension Insurance',
  new38: 'Medical Insurance',
  new39: 'Maternity Insurance',
  new40: 'Unemployment Insurance',
  new41: 'Default account',
  new42: 'Time State',
  new43: 'Calculating salary filter',
  new44: 'Error list',
  new45: 'terminate',
  new46: 'Executor',
  new47: 'Pay',
  new48: 'Data Type',
  new49: 'Trial run',
  new50: 'Employee List',
  new51: 'Problem Employee',
  new52: 'Check the trial run will not generate employee payroll',
  new53:
    'The test run results are not saved to the database, only for confirmation before the official salary calculation.',
  new54: 'End process',
  new55: 'Restart process',
  new56: 'Payment Actually Paid',
  new57: 'Payable Salary',
  new58: 'Error',
  new59: 'Payment Type',
  new60: 'Payment Method',
  new61: 'Please select at least one item! ',
  new62: 'Individual tax',
  new63: 'Estimated date of resignation',
  new64: 'Remarks on the reason for leaving',
  new65: 'Work transfer person',
  new66: 'Work handover matters',
  new67: 'Your suggestions for the current department',
  new68: 'Your suggestion to the company',
  new69: 'Handover content',
  new70: 'Handover personnel',
  new71: 'First month',
  new72: 'Second month',
  new73: 'Third month',
  new74: 'Fourth month',
  new75: 'Fifth month',
  new76: 'Sixth month',
  new77: 'average',
  new78: 'Self-evaluation during the trial period',
  new79: 'Trial period summary report',
  new80: 'Personal work development report',
  new81: 'Running',
  new82: 'Payslip',
  new83: 'Provided Fund',
  new84: 'Rerun payroll',
  new85: 'Payment area',
  new86: 'System error',
  new87: 'System error, please contact administrator!',
  new88: 'Online Banking Data',
  new89: 'Number',
  new90: 'Execution Time',
  new91: 'Evaluation Result',
  new92: 'Evaluation Name',
  new93: 'Evaluation start date',
  new94: 'Evaluation end date',
  new95: 'Evaluation',
  new96: 'Evaluated Data',
  new97: 'Original Data',
  new98: 'Payment Result',
  new99: 'Original salary data',
  new100: 'Import',
  new101: 'Release',
  new102: 'Task',
  new103: 'Data Type',
  new104: 'Apply for a manual number',
  new105: 'Applicant name',
  new106: 'Salary payment month',
  new107: 'Number of payments',
  new108: 'Total amount paid',
  new109: 'paid',
  new110: 'Unpaid',
  new111: 'Not apply',
  new112: 'Pending Payment',
  new115: 'Pay',
  new124: 'Average Salary',
  new126: '13 Salary',
  new127: 'Compensation',
  new128: 'Compensation Multiplier',
  new129: 'Works',
  new130: 'City Avg Salary',
  new134: 'Select a document',
  new135: 'Whether to overwrite the original data',
  new136: 'Download template',
  new140: 'Payment Agreement of China Merchants Bank',
  new141: 'Payment Agreement',
  new142: 'Please click this link',
  new143: 'Third party application authorization',
  new145: 'Agency Fees',
  new146: 'Pension Company',
  new147: 'Medical Company',
  new148: 'Illness Company',
  new149: 'Maternity Company',
  new150: 'Unemployment Company',
  new151: 'Fund Company',
  new152: 'Pit Company',
  new153: 'Cost',
  new154: 'Fund',
  new155: 'Fund Plan',
  new156: 'Illness',
  new157: 'Maternity',
  new158: 'Medical',
  new159: 'Unemployment',
  new160: 'Pension',
  new161: 'Plan',
  new162: 'Personal Cost',
  new163: 'Fund Company',
  new164: 'Fund Plan Company',
  new165: 'Illness Company',
  new166: 'Injury Company',
  new167: 'Maternity Company',
  new168: 'Medical Company',
  new169: 'Pension Company',
  new170: 'Unemployment Company',
  new171: 'Plan Company',
  new172: 'Company Cost',
  new173: 'Amount of Last Month',
  new174: 'Difference',
  new121: 'Authentication',
  new179: 'Year',
  new180: 'Start Month',
  new181: 'End Month',
  new182: 'Dimension',
  new183: 'Method',
  new184: 'Sub Org.',
  new186: 'Plan',
  new187: 'Year',
  new189: 'Total Salary(CNY)',
  new190: 'Adjust Percentage(%)',
  new191: 'Total Budget',
  new192: 'Refine Level',
  new197: 'Organization List',
  new204: 'Open',
  new205: 'Hold',
  new206: 'Adjusted Amount(CNY)',
  new207: 'Total Budget(CNY)',
  new210: 'File size cannot exceed',
  new211: 'Dimension',
  new212: 'Employee List',
  new213: 'Paid in Last Month',
  new214: 'Entry Date',
  new215: 'Reasons of Termination',
  new216: 'Please take the base number from the range:',
  new217: 'Filter out employees',
  new218: 'Success',
  new219: 'Working Years Analysis',
  new220: 'Number of People',
  new221: 'Please input keyword',
  new222: 'Longitude and latitude',
  new223: 'Address',
  new224: 'Please select a location',
  new225: 'Reimbursement Expenses',
  new226: 'Training Fee',
  new227: 'Overall Planning of Provident Fund',
  new228: 'Phone',
  new229: 'PC',
  new175: 'Attendance Days',
  new176: 'Actual Attendance Days',
  new177: 'Attendance Hours',
  new178: 'Actual Attendance Hours',
  new188: 'Wage Type',
  new300: 'Overtime',
  new301: 'Leave',
  new302: 'Absenteeism',
  new303: 'Late',
  new304: 'Leave Early',
  new305: 'Absence',
  new306: 'Sick',
  new307: 'Supplementary Pension',
  new308: 'Complementary Medicine',
  new309: 'Supplementary Ratio',
  new310: 'Payments',
  new311: 'Payment Check',
  new312: 'The account number or account name is not set',
  new313: 'Click OK to filter the employee who reported the error and initiate payment application',
  new314: 'Average to the First Month',
  new315: 'Conversion Rate',
  new316: 'Add address',
  new317:
    'Please submit genuine personal data, and the company has the right to hold you accountable for any false data you submit!',
  new318: "'s ",
  new319: 'No data to save',
  new320: 'Successfully urged, please wait for update!',
  new321: 'Visitor Management',
  new322: 'Real name authentication completed',
  new323:
    'Approved requirements are hidden by default, clicking the filter icon beside the status column can restore display!',
  new324: 'Resignation Application Date',
  new325: 'Planned Resignation Date',
  new326: 'Effective Resignation Date',
  brain01: 'Rank Analysis',
  brain02: 'Employee Turnover Analysis',
  brain03: 'Salary Analysis',
  brain04: 'Number of Leave and Overtime',
  brain05: 'Job Analysis',
  brain06: 'Recruitment Channel Analysis',
  brain07: 'Payable Statistics',
  brain08: 'Employee Regular Analysis',
  brain09: 'Workload Analysis',
  AwardImportName: 'award',
  BonusesImportName: 'Bonuses_Import_Template',
  PayRaiseImportName: 'pay_raise',
  attendancePaidSick: 'Paid Sick Leave',
  attendanceAnnualLeave: 'Annual Leave',
  attendanceOtherLeave: 'Other Leave',
  attendanceNightShift: 'Night Shift',
  entryQr: 'Onboarding QR Code',
  entryQrTip: 'Scan Code to Submit Personnel Files',
  workBadgeTitle: 'Work Badge Preview',
  workBadgeTooltip: 'Generate Work Badge',
  workBadgePreviewOnly: 'Preview only for your own badge. Download is not available.',
  workBadgeBatchDone: 'All work badges have been saved to the selected folder.',
  workBadgeBatchZipDone: 'Work badges have been downloaded as a ZIP file.',
  workBadgeGenerateFailed: 'Failed to generate work badge. Please try again later.',
  workBadgeNoPhoto: 'No Photo',
  workBadgeDownloadScope: 'The white card area is the downloaded badge',
  adminItemId: 'No.',
  adminItemName: 'Name',
  adminItemType: 'Type',
  adminItemQuantity: 'Quantity',
  adminItemUnit: 'Unit',
  adminItemBrand: 'Brand',
  adminItemModel: 'Model',
  adminItemCode: 'Code',
  adminItemMaterial: 'Material',
  adminItemColor: 'Color',
  adminItemSize: 'Size',
  adminItemSafetyStock: 'Safety Stock',
  adminItemAttachment: 'Attachment',
  adminItemTitle: 'Admin Item',
  adminItemAdd: 'Add Admin Item',
  adminItemEdit: 'Edit Admin Item',
  adminItemQuantityTip: 'Please enter a valid quantity (up to one decimal place)',
  placeholderAdminItemName: 'Please enter name',
  placeholderAdminItemType: 'Please select type',
  placeholderAdminItemQuantity: 'Please enter quantity',
  placeholderAdminItemUnit: 'Please enter unit',
  placeholderAdminItemBrand: 'Please enter brand',
  placeholderAdminItemModel: 'Please enter model',
  placeholderAdminItemCode: 'Please enter code',
  placeholderAdminItemMaterial: 'Please enter material',
  placeholderAdminItemColor: 'Please enter color',
  placeholderAdminItemSize: 'Please enter size',
  placeholderAdminItemSafetyStock: 'Please enter safety stock',
  placeholderAdminItemAttachment: 'Please enter attachment',
  // Cabinet Management
  adminCabinetTitle: 'Cabinet Management',
  adminCabinetAdd: 'Add Cabinet',
  adminCabinetEdit: 'Edit Cabinet',
  adminCabinetSerialNo: 'Serial No.',
  adminCabinetName: 'Name',
  adminCabinetType: 'Type',
  adminCabinetLayers: 'Layers',
  adminCabinetColumns: 'Columns',
  adminCabinetLocation: 'Location',
  adminCabinetUsedGrids: 'Used Grids',
  adminCabinetSafetyGrids: 'Safety Grids',
  adminCabinetBrand: 'Brand',
  adminCabinetModel: 'Model',
  adminCabinetCode: 'Code',
  adminCabinetMaterial: 'Material',
  adminCabinetColor: 'Color',
  adminCabinetEstablishmentDate: 'Establishment Date',
  adminCabinetStatus: 'Status',
  adminCabinetAttachment: 'Attachment',
  adminCabinetIntegerTip: 'Please enter an integer',
  placeholderAdminCabinetSerialNo: 'Please enter serial no.',
  placeholderAdminCabinetName: 'Please enter name',
  placeholderAdminCabinetType: 'Please select type',
  placeholderAdminCabinetLayers: 'Please enter layers',
  placeholderAdminCabinetColumns: 'Please enter columns',
  placeholderAdminCabinetLocation: 'Please enter location',
  placeholderAdminCabinetSafetyGrids: 'Please enter safety grids',
  placeholderAdminCabinetBrand: 'Please enter brand',
  placeholderAdminCabinetModel: 'Please enter model',
  placeholderAdminCabinetCode: 'Please enter code',
  placeholderAdminCabinetMaterial: 'Please enter material',
  placeholderAdminCabinetColor: 'Please enter color',
  placeholderAdminCabinetEstablishmentDate: 'Please select establishment date',
  placeholderAdminCabinetStatus: 'Please select status',
  cabinetStatusUsed: 'Used',
  cabinetStatusFree: 'Free',
  cabinetStatusBroken: 'Broken',
  // Vehicle Management
  adminVehicleTitle: 'Vehicle Management',
  adminVehicleAdd: 'Add Vehicle',
  adminVehicleEdit: 'Edit Vehicle',
  adminVehicleSerialNo: 'Serial No.',
  adminVehicleVehicle: 'Vehicle',
  adminVehicleApplyer: 'Applyer',
  adminVehicleDepartureTime: 'Departure Time',
  adminVehicleReturnTime: 'Return Time',
  adminVehicleRequestId: 'Request ID',
  adminVehicleRemark: 'Remark',
  adminVehicleUseTime: 'Use Time',
  placeholderAdminVehicleVehicle: 'Please select vehicle',
  placeholderAdminVehicleApplyer: 'Please select applyer',
  placeholderAdminVehicleDepartureTime: 'Please select departure time',
  placeholderAdminVehicleReturnTime: 'Please select return time',
  placeholderAdminVehicleRequestId: 'Please enter request ID',
  placeholderAdminVehicleRemark: 'Please enter remark',
  placeholderStartTime: 'Start Time',
  placeholderEndTime: 'End Time',
  // Item Stock Out/In
  itemStockTitle: 'Item Stock',
  itemStockSerialNo: 'Serial No.',
  itemStockName: 'Name',
  itemStockType: 'Type',
  itemStockActionType: 'Action Type',
  itemStockActionTime: 'Action Time',
  itemStockQuantity: 'Quantity',
  itemStockUnit: 'Unit',
  itemStockReason: 'Reason',
  itemStockOrderNo: 'Order No.',
  itemStockAmount: 'Amount(Yuan)',
  itemStockRemark: 'Remark',
  itemStockAttachment: 'Attachment',
  itemStockIn: 'Stock In',
  itemStockOut: 'Stock Out',
  itemStockInTime: 'Stock In Time',
  itemStockOutTime: 'Stock Out Time',
  itemStockItem: 'Purchasing Item',
    purchasingItem: 'Purchasing Item',
  placeholderItemStockSerialNo: 'Please enter serial no.',
  placeholderItemStockName: 'Please enter name',
  placeholderItemStockActionType: 'Please select action type',
  placeholderItemStockDateRange: 'Please select date range',
  placeholderItemStockItem: 'Please select item',
    placeholderPurchasingItem: 'Please select Purchasing Item',
  placeholderItemStockTime: 'Please select time',
  placeholderItemStockQuantity: 'Please enter quantity',
  placeholderItemStockReason: 'Please enter reason',
  placeholderItemStockOrderNo: 'Please enter order no.',
  placeholderItemStockAmount: 'Please enter amount',
  placeholderItemStockRemark: 'Please enter remark',
  itemStockInsufficient: 'Insufficient stock',
  // Cabinet allocation overview
  adminOverviewTitle: 'System Overview',
  totalWardrobe: 'Total Wardrobes',
  totalShoeCabinet: 'Total Shoe Cabinets',
  totalDormitory: 'Total Dormitories',
  totalOccupancy: 'Total Occupancy',
  unitBuilding: '',
  unitPerson: '',
  comparedToLastMonth: 'vs last month',
  occupancyRate: 'Occupancy Rate',
  allocated: 'Allocated',
  pendingAllocation: 'Pending',
  // Cabinet allocation table
  cabinetEmpName: 'Employee Name',
  cabinetEmpNo: 'Employee No.',
  cabinetDept: 'Department',
  cabinetType: 'Cabinet Type',
  cabinetNo: 'No.',
  cabinetTime: 'Allocation Time',
  cabinetStatus: 'Status',
  recentAllocationRecord: 'Recent Allocation Records',
  viewAll: 'View All',
  // Cabinet allocation list
  cabinetAllocationTitle: 'Cabinet Allocation',
  cabinetAllocationSerialNo: 'Serial No.',
  cabinetAllocationName: 'Name',
  cabinetAllocationType: 'Type',
  cabinetAllocationEmp: 'Employee',
  cabinetAllocationEmpCoding: 'Employee ID',
  cabinetAllocationEmpName: 'Employee Name',
  cabinetAllocationLayerNo: 'Layer No.',
  cabinetAllocationColumnNo: 'Column No.',
  cabinetAllocationTime: 'Allocation Time',
  cabinetAllocationReason: 'Reason',
  cabinetAllocationOrderNo: 'Request No.',
  cabinetAllocationRemark: 'Remark',
  cabinetAllocationAttachment: 'Attachment',
  cabinetAllocation: 'Allocate',
  cabinetCancel: 'Cancel',
  confirmCancelAllocation: 'Are you sure you want to cancel the allocation?',
  placeholderCabinetAllocationSerialNo: 'Please enter serial no.',
  placeholderCabinetAllocationName: 'Please enter name',
  placeholderCabinetAllocationType: 'Please select type',
  placeholderCabinetAllocationEmp: 'Please select employee',
  placeholderCabinetAllocationEmpCoding: 'Please enter employee ID',
  placeholderCabinetAllocationEmpName: 'Please enter employee name',
  placeholderCabinetAllocationLayerNo: 'Please enter layer no.',
  placeholderCabinetAllocationColumnNo: 'Please enter column no.',
  placeholderCabinetAllocationTime: 'Please select allocation time',
  placeholderCabinetAllocationReason: 'Please enter reason',
  placeholderCabinetAllocationOrderNo: 'Please enter request no.',
  placeholderCabinetAllocationRemark: 'Please enter remark',
  // Cabinet apply
  cabinetApplyTitle: 'Cabinet Apply',
  applyDate: 'Apply Date',
  applyReason: 'Apply Reason',
  placeholderApplyDate: 'Please select apply date',
  placeholderApplyReason: 'Please enter apply reason',
  placeholderCabinetType: 'Please select cabinet type',
  placeholderPhone: 'Please enter phone number',
  cabinetAllocateSuccess: 'Allocate success',
  // Loan
  borrowPayFieldAmount: 'Amount',
  borrowPayAmountInWords: 'Amount in Words',
  borrowPayFieldCurrency: 'Currency',
  borrowPayAmountTip: 'Please enter a valid amount (up to one decimal place)',
  borrowPayAttachmentTip:
    'Please remit request to the Accounting denatment 5 days betore departure',
  // Repair
  repairTitle: 'Repair',
  repairEmpId: 'Employee ID',
  repairEmpName: 'Name',
  repairJobName: 'Job',
  repairOrgName: 'Department',
  repairPhone: 'Phone',
  repairType: 'Repair Type',
  repairAddress: 'Repair Address',
  repairFaultDescription: 'Fault Description',
  placeholderRepairPhone: 'Please enter phone number',
  placeholderRepairType: 'Please select repair type',
  placeholderRepairAddress: 'Please enter repair address',
  placeholderRepairFaultDescription: 'Please enter fault description',
  repairTypeFetchFailed: 'Failed to fetch repair types',
  // Gift Hospitality Apply
  titleGiftHospitality: 'Gift Hospitality Apply',
  formBudgetAmount: 'Budget Amount',
  formApplyAmount: 'Apply Amount',
  formLoanOrder: 'Loan Order',
  placeholderGiftContent: 'Please enter content',
  placeholderGiftQuantity: 'Please enter quantity',
  placeholderBudgetAmount: 'Please enter budget amount',
  placeholderApplyAmount: 'Please enter apply amount',
  placeholderValidNumber: 'Please enter a valid number',
  placeholderValidAmount: 'Please enter a valid amount',
  placeholderGiftReason: 'Please enter reason',
  placeholderLoanOrder: 'Please select loan order',
  // Stantauto custom working meal
  dinnerStantautoTitle: 'Working Meal',
  dinnerTime: 'Time',
  dinnerPeopleNum: 'Number of People',
  dinnerMealType: 'Meal Type',
  dinnerCopies: 'Copies',
  dinnerMealLunch: 'Lunch',
  dinnerMealDinner: 'Dinner',
  placeholderDinnerTime: 'Please select time',
  placeholderDinnerPeopleNum: 'Please enter number of people, greater than 0',
  placeholderDinnerMealType: 'Please select meal type',
  placeholderDinnerCopies: 'Please enter copies',
  placeholderOrgName: 'Please enter department',
  // Budget Management
  adminBudgetTitle: 'Budget Management',
  adminBudgetAdd: 'Add Budget',
  adminBudgetEdit: 'Edit Budget',
  adminBudgetSerialNo: 'Serial No.',
  adminBudgetYear: 'Year',
  adminBudgetDept: 'Department',
  adminBudgetCostItem: 'Cost Item',
  adminBudgetCostItemType: 'Cost Item Type',
  adminBudgetJan: 'Jan',
  adminBudgetFeb: 'Feb',
  adminBudgetMar: 'Mar',
  adminBudgetApr: 'Apr',
  adminBudgetMay: 'May',
  adminBudgetJun: 'Jun',
  adminBudgetJul: 'Jul',
  adminBudgetAug: 'Aug',
  adminBudgetSep: 'Sep',
  adminBudgetOct: 'Oct',
  adminBudgetNov: 'Nov',
  adminBudgetDec: 'Dec',
  adminBudgetTotal: 'Total Budget',
  adminBudgetRemark: 'Remark',
  placeholderAdminBudgetYear: 'Please enter year',
  placeholderAdminBudgetDept: 'Please select department',
  placeholderAdminBudgetCostItem: 'Please select cost item',
  placeholderAdminBudgetCostItemType: 'Auto-filled cost item type',
  placeholderAdminBudgetMonth: 'Please enter budget',
  placeholderAdminBudgetTotal: 'Please enter total budget',
  placeholderAdminBudgetRemark: 'Please enter remark',
  placeholderAdminBudgetSerialNo: 'Please enter serial no.',
  adminBudgetYearTip: 'Please enter a valid year (e.g. 2026)',
  // Cost Management
  adminCostTitle: 'Cost Management',
  adminCostAdd: 'Add Cost',
  adminCostEdit: 'Edit Cost',
  adminCostSerialNo: 'Serial No.',
  adminCostDept: 'Department',
  adminCostCostItem: 'Cost Item',
  adminCostCostItemType: 'Cost Item Type',
  adminCostAmount: 'Cost Item Amount',
  adminCostDate: 'Cost Date',
  adminCostRemark: 'Remark',
  adminCostYear: 'Year',
  placeholderAdminCostSerialNo: 'Please enter serial no.',
  placeholderAdminCostDept: 'Please select department',
  placeholderAdminCostCostItem: 'Please select cost item',
  placeholderAdminCostCostItemType: 'Auto-filled cost item type',
  placeholderAdminCostAmount: 'Please enter cost amount, at most one decimal place',
  placeholderAdminCostDate: 'Please select date',
  placeholderAdminCostRemark: 'Please enter remark',
  placeholderAdminCostYear: 'Please enter year',
  adminCostAmountTip: 'Please enter a valid number with at most one decimal place',
  // Car Rental
  peopleCount: 'Number of People',
  companions: 'Companions',
  vehicleType: 'Required Vehicle',
  fromLocation: 'Departure',
  toLocation: 'Destination',
  distance: 'Estimated Distance (km)',
  startTime: 'Departure Time',
  returnTime: 'Expected Return Time',
  placeholderPeopleCount: 'Please enter number of people, greater than 0',
  placeholderPeopleCountInvalid: 'Please enter an integer greater than 0',
  placeholderCompanions: 'Please enter companions',
  placeholderFromLocation: 'Please select departure from map',
  placeholderToLocation: 'Please select destination from map',
  placeholderDistance: 'Please enter estimated distance',
  placeholderDistanceInvalid: 'Please enter a valid number with at most one decimal place',
  // stantauto reimbursement (TAPD 4.22)
  reimburseStantautoInvolvedCities: 'Cities involved',
  reimburseStantautoExchangeRate: 'Exchange rate',
  reimburseStantautoExchangeRateTip: 'Up to 6 decimal places',
  reimburseStantautoBusinessTrip: 'Business trip',
  reimburseStantautoAccounting: 'GL account',
  reimburseStantautoDirectSettlement: 'Direct settlement',
  reimburseStantautoGrandTotal: 'Grand total',
  reimburseStantautoPrepayAmount: 'Prepaid loan amount',
  reimburseStantautoPayableAmount: 'Amount payable',
  reimburseStantautoDateRow: 'Date',
  reimburseStantautoSelectDate: 'Select date',
  reimburseStantautoEnterAmount: 'Enter amount',
  reimburseStantautoRowAmount: 'Amount',
  reimburseStantautoAddDateCol: 'Add date column',
  reimburseStantautoRemoveDateCol: 'Remove date column',
  reimburseStantautoNoInvoiceConfirm: 'No invoice attachment uploaded. Submit anyway?',
  reimburseStantautoInvoiceRecognizing: 'Invoice recognition in progress. Please submit again shortly.',
  reimburseStantautoDuplicateInvoice:
    'Invoice no. {no} is duplicate. Please verify before submitting.',
  reimburseStantautoSelectBusinessTrip: 'Select business trip',
  reimburseStantautoMatrixDateRequired: 'Please select a date for columns that contain amounts',
  reimburseStantautoMatrixAccountRequired:
    'Please select a GL account for each expense row that has amounts',
  reimburseStantautoSensitive: 'Contains sensitive invoice',
  reimburseStantautoNoInvoiceTag: 'No invoice',
  // Office Admin Overview
  itemStockWarning: 'Item Stock Warning',
  cabinetAllocationStatus: 'Cabinet Allocation Status',
  preActualAnalysis: 'Budget vs Actual Analysis',
  costAnalysis: 'Cost Analysis',
  vehicleInUse: 'Vehicles in Use',
  vehicleNumber: 'Number',
  vehicleName: 'Vehicle',
  vehicleApplicant: 'Applicant',
  vehicleDepartureTime: 'Departure Time',
  vehicleReturnTime: 'Return Time',
  totalGrids: 'Total Grids',
  usedGrids: 'Used Grids',
  safetyGrids: 'Safety Grids',
  budgetAmount: 'Budget',
  actualAmount: 'Actual Amount',
  selectYear: 'Select Year',
  dimension: 'Dimension',
  dimensionDept: 'Department',
  dimensionCostType: 'Cost Type',
  dimensionCostItem: 'Cost Item',
  preActualBarTitle: 'Budget vs Actual Comparison',
  costMonthCompare: 'Monthly Cost Comparison',
  costDeptCompare: 'Department Cost Comparison',
  costItemCompare: 'Cost Item Comparison',
  costGrowthUp: 'YoY ↑',
  costGrowthDown: 'YoY ↓',
  annualBudget: 'Annual Budget',
  annualActualExpense: 'Annual Actual Expense',
  remainingBudget: 'Remaining Budget',
  budgetUsageRate: 'Budget Usage Rate',
  currentYearAmount: 'Current Year',
  lastYearAmount: 'Last Year',
  ...enUS,
};

export default en;
